const toCompetencies = (labels) =>
   labels.map((label, i) => ({ index: i + 1, label }));

export const BM_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'fractions',
         label: 'Fractions and Decimals',
         start: 1,
         count: 10,
         mean: 7.79,
         stdDev: 2.45,
         ranges: [
            [0, 6.56, 'Beginner'],
            [6.57, 9.02, 'Basic'],
            [9.03, 10, 'Competent'],
         ],
      },
      {
         key: 'buying',
         label: 'Buying and Selling Products',
         start: 11,
         count: 16,
         mean: 10.08,
         stdDev: 3.88,
         ranges: [
            [0, 8.13, 'Beginner'],
            [8.14, 12.02, 'Basic'],
            [12.03, 16, 'Competent'],
         ],
      },
      {
         key: 'salaries',
         label: 'Salaries and Wages',
         start: 27,
         count: 9,
         mean: 4.82,
         stdDev: 1.42,
         ranges: [
            [0, 4.1, 'Beginner'],
            [4.11, 5.53, 'Basic'],
            [5.54, 9, 'Competent'],
         ],
      },
      {
         key: 'business',
         label: 'Business Data',
         start: 36,
         count: 5,
         mean: 3.02,
         stdDev: 1.22,
         ranges: [
            [0, 2.4, 'Beginner'],
            [2.41, 3.63, 'Basic'],
            [3.64, 36, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 20.94, 'Beginner'],
      [20.95, 28.23, 'Basic'],
      [28.24, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Fractions and Decimals', start: 1, end: 10 },
      { label: 'B. Buying and Selling Products', start: 11, end: 26 },
      { label: 'C. Salaries and Wages', start: 27, end: 35 },
      { label: 'D. Business Data', start: 36, end: 40 },
   ],
   competencies: toCompetencies([
      'Express: (a) fractions to decimal and percent forms, (b) decimals to fractions and percent forms, (c) percent to fractions and decimal forms.',
      'Express: (a) fractions to decimal and percent forms, (b) decimals to fractions and percent forms, (c) percent to fractions and decimal forms.',
      'Express: (a) fractions to decimal and percent forms, (b) decimals to fractions and percent forms, (c) percent to fractions and decimal forms.',
      'Give real-life situations to illustrate fractions, decimals, and percent',
      'Give real-life situations to illustrate fractions, decimals, and percent',
      'Give real-life situations to illustrate fractions, decimals, and percent',
      'Solve problems involving fractions, decimals, and percent',
      'Solve problems involving fractions, decimals, and percent',
      'Solve problems involving fractions, decimals, and percent',
      'Solve problems involving fractions, decimals, and percent',
      'Identify the different kinds of proportions and write examples of real-life situations for each',
      'Solve problems involving direct, inverse and partitive proportion',
      'Differentiate Mark-on, Mark down and Mark-up',
      'Obtain Mark-on, Mark-down, and Mark-up given price of a product',
      'Differentiate mark-up from margins',
      'Describe how gross margins is used in sales',
      'Compute single trade discounts and discount series',
      'Differentiate profit from loss',
      'Illustrate how profit is obtained and how to avoid loss in a given transaction',
      'Determine the break-even point',
      'Solve problems involving buying and selling products',
      'Compute interest specifically as applied to mortgage, amortization, and on services/utilities and on deposits and loans',
      'Illustrate the different types of commissions',
      'Compute commissions on cash basis and commission on instalment basis',
      'Compute down payment, gross balance and current increased balance',
      'Solve problems involving interests and commissions',
      'Define salary, wage, income, benefits',
      'Compute gross and net earnings',
      'Define each of the benefits given to wage earners',
      'Distinguish taxable from nontaxable benefits',
      'Enumerate the standard deductions with the corresponding computation',
      'Identify the variables needed in the computation of the overtime',
      'Compute overtime pay',
      'Use E- spread sheet in the computation of salary and overtime pay',
      'Present graphical representation of the details or particulars of the salary',
      'Compare the forms (textual, tabular and graphical) of business data.',
      'Analyze and interprets the data presented in the table using measures of central tendency and variability and tests of significant differences',
      'Describe the different kinds of graphs and its essential parts for data presentation',
      'Give a set of business data; identify the graphs to be used',
      'Analyze and interpret the data presented in a graph/table',
   ]),
};

export const BFG12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'nature',
         label: 'Nature of Finance',
         start: 1,
         count: 10,
         mean: 5.9,
         stdDev: 1.88,
         ranges: [
            [0, 5.89, 'Beginner'],
            [5.9, 7.78, 'Basic'],
            [7.79, 10, 'Competent'],
         ],
      },
      {
         key: 'planning',
         label: 'Financial Planning',
         start: 11,
         count: 10,
         mean: 2.9,
         stdDev: 0.82,
         ranges: [
            [0, 5.15, 'Beginner'],
            [5.16, 7.01, 'Basic'],
            [7.02, 10, 'Competent'],
         ],
      },
      {
         key: 'sources',
         label: 'Sources of Funds and Returns',
         start: 21,
         count: 10,
         mean: 3.47,
         stdDev: 0.77,
         ranges: [
            [0, 5.39, 'Beginner'],
            [5.4, 7.14, 'Basic'],
            [7.15, 21, 'Competent'],
         ],
      },
      {
         key: 'risk',
         label: 'Risk Investments',
         start: 31,
         count: 10,
         mean: 2.88,
         stdDev: 1.36,
         ranges: [
            [0, 5.4, 'Beginner'],
            [5.41, 7.12, 'Basic'],
            [7.13, 10, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 21.85, 'Beginner'],
      [21.86, 26.79, 'Basic'],
      [26.8, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Nature of Finance', start: 1, end: 10 },
      { label: 'B. Financial Planning', start: 11, end: 20 },
      { label: 'C. Sources of Funds and Returns', start: 21, end: 30 },
      { label: 'D. Risk Investments', start: 31, end: 40 },
   ],
   competencies: toCompetencies([
      'Explain the major role of financial management and the different individuals involved',
      'Explain the major role of financial management and the different individuals involved',
      'Explain the major role of financial management and the different individuals involved',
      'Distinguish a financial institution from financial instrument and financial market',
      'Distinguish a financial institution from financial instrument and financial market',
      'Distinguish a financial institution from financial instrument and financial market',
      'Explain the flow of funds within an organization – through and from the enterprise—and the role of the financial manager',
      'Explain the flow of funds within an organization – through and from the enterprise—and the role of the financial manager',
      'Explain the flow of funds within an organization – through and from the enterprise—and the role of the financial manager',
      'Explain the flow of funds within an organization – through and from the enterprise—and the role of the financial manager',
      'Identify the steps in the financial planning process',
      'Identify the steps in the financial planning process',
      'Identify the steps in the financial planning process',
      'Illustrate the formula and format for the preparation of budgets and projected financial statement',
      'Illustrate the formula and format for the preparation of budgets and projected financial statement',
      'Illustrate the formula and format for the preparation of budgets and projected financial statement',
      'Explain tools in managing cash, receivables, and inventory',
      'Explain tools in managing cash, receivables, and inventory',
      'Explain tools in managing cash, receivables, and inventory',
      'Explain tools in managing cash, receivables, and inventory',
      'Compare and contrast the loan requirements of the different banks and nonbank institutions ',
      'Compare and contrast the loan requirements of the different banks and nonbank institutions ',
      'Calculate future value and present value of money',
      'Calculate future value and present value of money',
      'Compute loan amortization using mathematical concepts and the present value tables',
      'Compute loan amortization using mathematical concepts and the present value tables',
      'Apply mathematical concepts and tools in computing for finance and investment problems',
      'Apply mathematical concepts and tools in computing for finance and investment problems',
      'Explain the risk-return trade-off',
      'Explain the risk-return trade-off',
      'Compare and contrast the different types of investments',
      'Compare and contrast the different types of investments',
      'Measure and list ways to minimize or reduce investment risks in simple case problems',
      'Measure and list ways to minimize or reduce investment risks in simple case problems',
      'Measure and list ways to minimize or reduce investment risks in simple case problems',
      'Enumerate money management philosophies',
      'Enumerate money management philosophies',
      'Illustrate the money management cycle and gives examples of sound practices in earning, spending, saving, and investing money',
      'Illustrate the money management cycle and gives examples of sound practices in earning, spending, saving, and investing money',
      'Illustrate the money management cycle and gives examples of sound practices in earning, spending, saving, and investing money',
   ]),
};

export const BESRG12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'naturebusiness',
         label: 'Nature and Forms of Business',
         start: 1,
         count: 10,
         mean: 6.41,
         stdDev: 2.3,
         ranges: [
            [0, 5.25, 'Beginner'],
            [5.26, 7.56, 'Basic'],
            [7.57, 10, 'Competent'],
         ],
      },
      {
         key: 'philosophies',
         label: 'Philosophies, Beliefs and Values',
         start: 11,
         count: 10,
         mean: 5.21,
         stdDev: 1.74,
         ranges: [
            [0, 4.33, 'Beginner'],
            [4.34, 6.08, 'Basic'],
            [6.09, 10, 'Competent'],
         ],
      },
      {
         key: 'responsibilities',
         label: 'Responsibilities of Entrepreneurs',
         start: 21,
         count: 10,
         mean: 5.71,
         stdDev: 1.79,
         ranges: [
            [0, 4.81, 'Beginner'],
            [4.82, 6.61, 'Basic'],
            [6.62, 10, 'Competent'],
         ],
      },
      {
         key: 'importance',
         label: 'Importance of doing Business',
         start: 31,
         count: 5,
         mean: 2.24,
         stdDev: 1.06,
         ranges: [
            [0, 1.7, 'Beginner'],
            [1.71, 2.77, 'Basic'],
            [2.78, 5, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 15.68, 'Beginner'],
      [15.69, 20.7, 'Basic'],
      [20.71, 35, 'Competent'],
   ],
   sections: [
      { label: 'A. Nature and Forms of Business', start: 1, end: 10 },
      { label: 'B. Philosophies, Beliefs and Values', start: 11, end: 20 },
      { label: 'C. Responsibilities of Entrepreneurs', start: 21, end: 30 },
      { label: 'D. Importance of doing Business', start: 31, end: 35 },
   ],
   competencies: toCompetencies([
      'Differentiate the forms of business organizations in terms of their purpose and role in socioeconomic development',
      'Differentiate the forms of business organizations in terms of their purpose and role in socioeconomic development',
      'Differentiate the forms of business organizations in terms of their purpose and role in socioeconomic development',
      'Illustrate how fairness, accountability, transparency and stewardship is observed in business and nonprofit organizations',
      'Illustrate how fairness, accountability, transparency and stewardship is observed in business and nonprofit',
      'Illustrate how fairness, accountability, transparency and stewardship is observed in business and nonprofit organizations',
      'Illustrate how fairness, accountability, transparency and stewardship is observed in business and nonprofit organizations',
      'Formulate a “code of ethics” that reflect core principles derived from analyses',
      'Formulate a “code of ethics” that reflect core principles derived from analyses',
      'Formulate a “code of ethics” that reflect core principles derived from analyses',
      'Illustrate how philosophies are reflected into business practices',
      'Illustrate how philosophies are reflected into business practices',
      'Illustrate how philosophies are reflected into business practices',
      'Explain how the belief systems influence business practices',
      'Explain how the belief systems influence business practices',
      'Explain how the belief systems influence business practices',
      'Explain how the belief systems influence business practices',
      'Explain how the belief systems influence business practices',
      'Generate ways to improve business practices guided by the philosophies, belief system or Filipino values',
      'Generate ways to improve business practices guided by the philosophies, belief system or Filipino values',
      'Discuss the responsibilities and accountabilities of entrepreneurs',
      'Discuss the responsibilities and accountabilities of entrepreneurs',
      'Discuss the responsibilities and accountabilities of entrepreneurs',
      'Formulate a morally defensible position on ethical issues in entrepreneurship like basic fairness, personnel and customer relations distribution dilemmas, fraud, unfair competition, unfair communication, nonrespect of agreements, environmental degradation',
      'Formulate a morally defensible position on ethical issues in entrepreneurship like basic fairness, personnel and customer relations distribution dilemmas, fraud, unfair competition, unfair communication, nonrespect of agreements, environmental degradation',
      'Formulate a morally defensible position on ethical issues in entrepreneurship like basic fairness, personnel and customer relations distribution dilemmas, fraud, unfair competition, unfair communication, nonrespect of agreements, environmental degradation',
      'Describe the different models and frameworks of social responsibility',
      'Describe the different models and frameworks of social responsibility',
      'Formulate a framework of social responsibility that reflects the practice of sound business',
      'Formulate a framework of social responsibility that reflects the practice of sound business',
      'Explain the importance of establishing and sustaining business enterprises as a source of job opportunities and financial freedom',
      'Explain the importance of establishing and sustaining business enterprises as a source of job opportunities and financial freedom',
      'Explain the importance of establishing and sustaining business enterprises as a source of job opportunities and financial freedom',
      'Explain the importance of establishing and sustaining business enterprises as a source of job opportunities and financial freedom',
      'Explain the importance of establishing and sustaining business enterprises as a source of job opportunities and financial freedom',
   ]),
};

export const AEG12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'economics_as_applied_to_science',
         label: 'Economics as Applied to Science',
         start: 1,
         count: 10,
         mean: 5.92,
         stdDev: 1.42,
         ranges: [
            [0, 5.2, 'Beginner'],
            [5.21, 6.63, 'Basic'],
            [6.64, 10, 'Competent'],
         ],
      },
      {
         key: 'the_law_of_supply_and_demand',
         label: 'The Law of Supply and Demand',
         start: 11,
         count: 10,
         mean: 5.71,
         stdDev: 1.79,
         ranges: [
            [0, 4.81, 'Beginner'],
            [4.82, 6.61, 'Basic'],
            [6.62, 10, 'Competent'],
         ],
      },
      {
         key: 'industry_analysis',
         label: 'Industry Analysis',
         start: 21,
         count: 10,
         mean: 5.71,
         stdDev: 1.79,
         ranges: [
            [0, 4.81, 'Beginner'],
            [4.82, 6.62, 'Basic'],
            [6.63, 10, 'Competent'],
         ],
      },
      {
         key: 'socioeconomic_impacts_of_business',
         label: 'Socioeconomic Impacts of Business',
         start: 31,
         count: 10,
         mean: 5,
         stdDev: 1.82,
         ranges: [
            [0, 4.08, 'Beginner'],
            [4.09, 5.91, 'Basic'],
            [5.92, 10, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 18.51, 'Beginner'],
      [18.52, 22.86, 'Basic'],
      [22.87, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Economics as Applied to Science', start: 1, end: 10 },
      { label: 'B. The Law of Supply and Demand', start: 11, end: 20 },
      { label: 'C. Industry Analysis', start: 21, end: 30 },
      { label: 'D. Socioeconomic Impacts of Business', start: 31, end: 40 },
   ],
   competencies: toCompetencies([
      'Differentiate economics as social science and applied science in terms of nature and scope',
      'Differentiate economics as social science and applied science in terms of nature and scope',
      'Examine the utility and application of applied economics to solve economic issues and problems',
      'Examine the utility and application of applied economics to solve economic issues and problems',
      'Analyze market demand, market supply and market equilibrium',
      'Analyze market demand, market supply and market equilibrium',
      'Determine the implications of market pricing on economic decision-making',
      'Determine the implications of market pricing on economic decision-making',
      'Differentiate various market structures in terms of: (a) number of sellers, (b) types of products, (c) entry/exit to market, (d) pricing power',
      'Differentiate various market structures in terms of: (a) number of sellers, (b) types of products, (c) entry/exit to market, (d) pricing power',
      'Analyze the effects of contemporary economic issues affecting the Filipino entrepreneur',
      'Analyze the effects of contemporary economic issues affecting the Filipino entrepreneur',
      'Analyze the effects of contemporary economic issues affecting the Filipino entrepreneur',
      'Analyze the effects of contemporary economic issues affecting the Filipino entrepreneur',
      'Analyze the effects of contemporary economic issues affecting the Filipino entrepreneur',
      'Analyze the effects of contemporary economic issues affecting the Filipino entrepreneur',
      'Analyze the effects of contemporary economic issues affecting the Filipino entrepreneur',
      'Analyze the effects of contemporary economic issues affecting the Filipino entrepreneur',
      'Analyze the effects of contemporary economic issues affecting the Filipino entrepreneur',
      'Analyze the effects of contemporary economic issues affecting the Filipino entrepreneur',
      'Analyze different principles, tools, and techniques in creating a business',
      'Analyze different principles, tools, and techniques in creating a business',
      'Analyze different principles, tools, and techniques in creating a business',
      'Analyze different principles, tools, and techniques in creating a business',
      'Analyze different principles, tools, and techniques in creating a business',
      'Apply business principles, tools, and techniques in participating in various types of industries in the locality',
      'Apply business principles, tools, and techniques in participating in various types of industries in the locality',
      'Apply business principles, tools, and techniques in participating in various types of industries in the locality',
      'Apply business principles, tools, and techniques in participating in various types of industries in the locality',
      'Apply business principles, tools, and techniques in participating in various types of industries in the locality',
      'Explain the effects of the various socio-economic factors affecting business and industry',
      'Explain the effects of the various socio-economic factors affecting business and industry',
      'Explain the effects of the various socio-economic factors affecting business and industry',
      'Explain the effects of the various socio-economic factors affecting business and industry',
      'Explain the effects of the various socio-economic factors affecting business and industry',
      'Evaluate the viability and impacts of business on the community',
      'Evaluate the viability and impacts of business on the community',
      'Evaluate the viability and impacts of business on the community',
      'Evaluate the viability and impacts of business on the community',
      'Evaluate the viability and impacts of business on the community',
   ]),
};

export const BC_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'limit_and_continuity_functions',
         label: 'Limit and Continuity Functions',
         start: 1,
         count: 10,
         mean: 5.2,
         stdDev: 1.48,
         ranges: [
            [0, 5.19, 'Beginner'],
            [5.2, 6.68, 'Basic'],
            [6.69, 10, 'Competent'],
         ],
      },
      {
         key: 'derivatives',
         label: 'Derivatives',
         start: 11,
         count: 13,
         mean: 7.9,
         stdDev: 2.5,
         ranges: [
            [0, 5.79, 'Beginner'],
            [5.8, 7.74, 'Basic'],
            [7.75, 12, 'Competent'],
         ],
      },
      {
         key: 'antiderivatives_and_riemann_integral',
         label: 'Antiderivatives and Riemann Integral',
         start: 24,
         count: 17,
         mean: 7.9,
         stdDev: 2.5,
         ranges: [
            [0, 7.89, 'Beginner'],
            [7.9, 10.4, 'Basic'],
            [10.41, 18, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 17.89, 'Beginner'],
      [17.9, 23.08, 'Basic'],
      [23.09, 40, 'Competent'],
   ],
   sections: [
      { label: 'Limit and Continuity Functions', start: 1, end: 10 },
      { label: 'Derivatives', start: 11, end: 22 },
      { label: 'Antiderivatives and Riemann Integral', start: 23, end: 40 },
   ],
   competencies: toCompetencies([
      'Illustrate the limit of a function using a table of values and the graph of the function',
      'Distinguish between lim x→c f ( x ) and f(c)',
      'Illustrate the limit laws',
      'Apply the limit laws in evaluating the limit of algebraic functions (polynomial, rational, and radical',
      'Compute the limits of exponential, logarithmic, and trigonometric functions using tables of values and graphs of the functions',
      'Illustrate limits involving the expressions and using tables of values',
      'Illustrate continuity of a function at a number',
      'Determine whether a function is continuous at a number or not',
      'Illustrate continuity of a function on an interval',
      'Solves problems involving continuity of a function',
      'Illustrate the tangent line to the graph of a function at a given point',
      'Applies the definition of the derivative of a function at a given number',
      'Relate the derivative of a function to the slope of the tangent line',
      'Determine the relationship between differentiability and continuity of a function',
      'Apply the differentiation rules in computing the derivative of an algebraic, exponential, logarithmic, trigonometric functions and inverse trigonometric functions',
      'Illustrate the Extreme Value Theorem',
      'Solve optimization problems that yield polynomial functions',
      'Illustrate the Chain Rule of differentiation',
      'Solve problems using the Chain Rule',
      'Illustrate implicit differentiation',
      'Solve problems (including logarithmic, and inverse trigonometric functions) using implicit differentiation',
      'Solve situational problems involving related rates',
      'Illustrate an antiderivative of a function',
      'Compute the general antiderivative of polynomial, radical, exponential, and trigonometric functions',
      'Compute the antiderivative of a function using substitution rule',
      'Solve problems involving antidifferentiation',
      'Solve situational problems involving exponential growth and decay',
      'Solve situational problems involving exponential growth and decay',
      'Illustrate the definite integral as the limit of the Riemann sums',
      'Illustrate the definite integral as the limit of the Riemann sums',
      'Illustrate the Fundamental Theorem of Calculus',
      'Illustrate the Fundamental Theorem of Calculus',
      'Compute the definite integral of a function using the Fundamental Theorem of Calculus',
      'Compute the definite integral of a function using the Fundamental Theorem of Calculus',
      'Compute the definite integral of a function using the substitution rule',
      'Compute the definite integral of a function using the substitution rule',
      'Compute the area of a plane region using the definite integral',
      'Compute the area of a plane region using the definite integral',
      'Solve problems involving areas of plane regions',
      'Solve problems involving areas of plane regions',
   ]),
};

export const CESC_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'social_science_perspectives',
         label: 'Social Science Perspectives',
         start: 1,
         count: 4,
         mean: 2.14,
         stdDev: 10.7,
         ranges: [
            [0, 1.6, 'Beginner'],
            [1.61, 2.68, 'Basic'],
            [2.69, 4, 'Competent'],
         ],
      },
      {
         key: 'communities',
         label: 'Communities',
         start: 5,
         count: 4,
         mean: 2.58,
         stdDev: 0.94,
         ranges: [
            [0, 2.1, 'Beginner'],
            [2.11, 3.05, 'Basic'],
            [3.06, 4, 'Competent'],
         ],
      },
      {
         key: 'community_engagement',
         label: 'Community Engagement',
         start: 9,
         count: 4,
         mean: 2.95,
         stdDev: 1.12,
         ranges: [
            [0, 2.38, 'Beginner'],
            [2.39, 3.51, 'Basic'],
            [3.52, 4, 'Competent'],
         ],
      },
      {
         key: 'community_solidarity',
         label: 'Community Solidarity',
         start: 13,
         count: 8,
         mean: 4.37,
         stdDev: 1.4,
         ranges: [
            [0, 3.66, 'Beginner'],
            [3.67, 5.07, 'Basic'],
            [5.08, 8, 'Competent'],
         ],
      },
      {
         key: 'community_action',
         label: 'Community Action',
         start: 21,
         count: 15,
         mean: 8.08,
         stdDev: 2.01,
         ranges: [
            [0, 7.07, 'Beginner'],
            [7.08, 9.09, 'Basic'],
            [9.1, 15, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 16.28, 'Beginner'],
      [16.29, 19.99, 'Basic'],
      [20, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Social Science Perspectives', start: 1, end: 4 },
      { label: 'B. Communities', start: 5, end: 8 },
      { label: 'C. Community Engagement', start: 9, end: 12 },
      { label: 'D. Community Solidarity', start: 13, end: 20 },
      { label: 'E. Community Action', start: 21, end: 35 },
   ],
   competencies: toCompetencies([
      'Explain the importance of studying community dynamics and community action in relation to applied social sciences and the learners’ future career options',
      'Explain the importance of studying community dynamics and community action in relation to applied social sciences and the learners’ future career options',
      'Define using various perspectives, e.g., social sciences, institutions, civil society, and local/grassroots level',
      'Define using various perspectives, e.g., social sciences, institutions, civil society, and local/grassroots level',
      'Analyze functions of communities in terms of structures, dynamics, and processes',
      'Analyze functions of communities in terms of structures, dynamics, and processes',
      'Differentiate typologies of communities',
      'Differentiate typologies of communities',
      'Recognize the value of undertaking community action modalities',
      'Recognize the value of undertaking community action modalities',
      'Acknowledge interrelationship of self and community in undertaking community action',
      'Acknowledge interrelationship of self and community in undertaking community action',
      'Explain forms of community engagement that contribute to community development through solidarity',
      'Explain forms of community engagement that contribute to community development through solidarity',
      'Recognize the importance of solidarity in promoting national and global community development (e.g. poverty alleviation)',
      'Recognize the importance of solidarity in promoting national and global community development (e.g. poverty alleviation)',
      'Explain the core values of community action initiatives (a. human rights, b. social equity, c. gender equality d. participatory, development)',
      'Explain the core values of community action initiatives (a. human rights, b. social equity, c. gender equality d. participatory, development)',
      'Analyze strategies of empowerment and advocacy of a community action initiative',
      'Analyze strategies of empowerment and advocacy of a community action initiative',
      'Explain the importance of commitment and action in participatory development for community well-being',
      'Explain the importance of commitment and action in participatory development for community well-being',
      'Assess selected community-action initiatives based on its core values and principles',
      'Assess selected community-action initiatives based on its core values and principles',
      'Explain the methodologies and approaches in community action',
      'Explain the methodologies and approaches in community action',
      'Apply systematic methods of community action in understanding community',
      'Apply systematic methods of community action in understanding community',
      'Formulate a community action',
      'Formulate a community action',
      'Plan using participatory approaches',
      'Plan using participatory approaches',
      'Implement community action plan',
      'Implement community action plan',
      'Implement community action plan',
   ]),
};

export const CHEM1_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'properties_of_matter',
         label: 'Properties of Matter',
         start: 1,
         count: 4,
         mean: 2.48,
         stdDev: 1.02,
         ranges: [
            [0, 1.96, 'Beginner'],
            [1.97, 2.99, 'Basic'],
            [3, 4, 'Competent'],
         ],
      },
      {
         key: 'atomic_structure',
         label: 'Atomic Structure',
         start: 5,
         count: 10,
         mean: 5.48,
         stdDev: 1.72,
         ranges: [
            [0, 4.61, 'Beginner'],
            [4.62, 6.34, 'Basic'],
            [6.35, 10, 'Competent'],
         ],
      },
      {
         key: 'gas_law',
         label: 'Gas Law',
         start: 15,
         count: 6,
         mean: 3.66,
         stdDev: 1.08,
         ranges: [
            [0, 3.11, 'Beginner'],
            [3.12, 4.2, 'Basic'],
            [4.21, 6, 'Competent'],
         ],
      },
      {
         key: 'molecular_and_atomic_bonds',
         label: 'Molecular and Atomic Bonds',
         start: 21,
         count: 20,
         mean: 10.48,
         stdDev: 2.27,
         ranges: [
            [0, 9.34, 'Beginner'],
            [9.35, 11.62, 'Basic'],
            [11.63, 20, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 18.32, 'Beginner'],
      [18.33, 22.04, 'Basic'],
      [22.05, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Properties of Matter', start: 1, end: 4 },
      { label: 'B. Atomic structure', start: 5, end: 14 },
      { label: 'C. Gas law', start: 15, end: 20 },
      { label: 'D. Molecular and atomic bonds', start: 21, end: 40 },
   ],
   competencies: toCompetencies([
      'Use properties of matter to identify substances and to separate them',
      'Recognize the formulas of common chemical substances',
      'Compare consumer products on the basis of their components for use, safety, qualityand cost',
      'Describe various simple separation techniques such as distillation, chromatography',
      'Recognize common isotopes and their uses.',
      'Represent compounds using chemical formulas, structural formulas and models',
      'Name compounds given their formula and write formula given the name of the compound',
      'Calculate the empirical formula from the percent composition of a compound',
      'Calculate molecular formula given molar mass',
      'Write and balanced chemical equations',
      'Construct mole or mass ratios for a reaction in order to calculate the amount of reactant needed or amount of product formed in terms of moles or mass',
      'Calculate percent yield and theoretical yield of the reaction',
      'Explain the concept of limiting reagent in a chemical reaction; identify the excess reagent(s)',
      'Determine mass relationship in a chemical reaction',
      'Define pressure and give the common units of pressure',
      'Use the gas laws to determine pressure, volume, or temperature of a gas under certain conditions of change',
      'Use the ideal gas equation to calculate pressure, volume, Temperature, or number of moles of a gas',
      'Use Dalton’s law of partial pressures to relate mole fraction and partial pressure of gases in a mixture',
      'Apply the principles of stoichiometry to determine the amounts (volume, number of moles, or mass) of gaseous reactants and products',
      'Relate the rate of gas effusion with molar mass',
      'Use quantum numbers to describe an electron in an atom',
      'Determine the magnetic property of the atom based on its electronic configuration',
      'Draw an orbital diagram to represent the electronic configuration of atoms',
      'Draw the Lewis structure of ions',
      'Draw the Lewis structure of ions',
      'Apply the octet rule in the formation of molecular covalent compounds',
      'Write the formula of molecular compounds formed by the nonmetallic elements of the representative block',
      'Write the formula of molecular compounds formed by the nonmetallic elements of the representative block',
      'Draw Lewis structure of molecular covalent compounds',
      'Describe the geometry of simple compounds',
      'Describe the geometry of simple compounds',
      'Determine the polarity of simple molecules',
      'Describe the different functional groups',
      'Describe structural isomerism; give examples',
      'Describe some simple reactions of organic compounds: combustion of organic fuels, addition, condensation, and saponification of fats',
      'Describe the formation and structure of polymers',
      'Explain the properties of some polymers in terms of their structure',
      'Describe the structure of proteins, nucleic acids, lipids, and carbohydrates, and relate them to their function',
      'Describe the structure of proteins, nucleic acids, lipids, and carbohydrates, and relate them to their function',
      'Describe the preparation of selected organic compounds',
   ]),
};

export const CHEM2_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'properties_of_liquids_and_solids',
         label: 'Properties of Liquids and Solids',
         start: 1,
         count: 17,
         mean: 8.03,
         stdDev: 2.48,
         ranges: [
            [0, 6.78, 'Beginner'],
            [6.79, 9.27, 'Basic'],
            [9.28, 17, 'Competent'],
         ],
      },
      {
         key: 'rates_of_reaction',
         label: 'Rates of Reaction',
         start: 18,
         count: 5,
         mean: 8.03,
         stdDev: 2.48,
         ranges: [
            [0, 2.2, 'Beginner'],
            [2.21, 3.43, 'Basic'],
            [3.44, 5, 'Competent'],
         ],
      },
      {
         key: 'spontaneous_change_entropy_and_free_energy',
         label: 'Spontaneous Change, Entropy, and Free Energy',
         start: 23,
         count: 18,
         mean: 8.03,
         stdDev: 2.48,
         ranges: [
            [0, 6.78, 'Beginner'],
            [6.79, 9.27, 'Basic'],
            [9.28, 18, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 17.5, 'Beginner'],
      [17.51, 21.47, 'Basic'],
      [21.48, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Properties of Liquids and Solids', start: 1, end: 17 },
      { label: 'B. Rates of Reaction', start: 18, end: 22 },
      {
         label: 'C. Spontaneous Change, Entropy, and Free Energy',
         start: 23,
         end: 40,
      },
   ],
   competencies: toCompetencies([
      'Use the kinetic molecular model to explain properties of liquids and solids',
      'Describe and differentiate the types of intermolecular forces',
      'Describe the following properties of liquids, and explain the effect of intermolecular forces on these properties: surface tension, viscosity, vapor pressure, boiling point, and molar heat of vaporization',
      'Explain the properties of water with its molecular structure and intermolecular forces',
      'Describe the difference in structure of crystalline and amorphous solids',
      'Interpret the phase diagram of water and carbon dioxide',
      'Determine and explain the heating and cooling curve of a substance',
      'Use different ways of expressing concentration of solutions: percent by mass, mole fraction, molarity, molality, percent by volume, percent by mass, ppm',
      'Perform stoichiometric calculations for reactions in solution',
      'Describe the effect of concentration on the colligative properties of solutions',
      'Differentiate the colligative properties of nonelectrolyte solutions and of electrolyte solutions',
      'Calculate boiling point elevation and freezing point depression from the concentration of a solute in a solution',
      'Calculate molar mass from colligative property data',
      'Describe laboratory procedures in determining concentration of solutions',
      'Explain the first law of thermodynamics',
      'Explain enthalpy of a reaction',
      'Calculate the change in enthalpy of a given reaction using Hess Law',
      'Describe how various factors influence the rate of a reaction',
      'Differentiate zero, first-, and second-order reactions',
      'Explain reactions qualitatively in terms of molecular collisions',
      'Explain activation energy and how a catalyst affects the reaction rate',
      'Cite and differentiate the types of catalysts',
      'Predict the spontaneity of a process based on entropy',
      'Explain the second law of thermodynamics and its significance',
      'Use Gibbs’ free energy to determine the direction of a reaction',
      'Explain chemical equilibrium in terms of the reaction rates of the forward and the reverse reaction',
      'Calculate equilibrium constant and the pressure or concentration of reactants or products in an equilibrium mixture',
      'State the Le Chatelier’s principle and apply it qualitatively to describe the effect of changes in pressure, concentration and temperature on a system at equilibrium',
      'Define Bronsted acids and bases',
      'Discuss the acid-base property of water',
      'Calculate ph from the concentration of hydrogen ion or hydroxide ions in aqueous solutions',
      'Describe how a buffer solution maintains its ph',
      'Calculate the ph of a buffer solution using the Henderson Hasselbalch equation',
      'Define oxidation and reduction reactions',
      'Balance redox reactions using the change in oxidation number method',
      'Identify the reaction occurring in the different parts of the cell',
      'Define reduction potential, oxidation potential, and cell potential',
      'Calculate the standard cell potential',
      'Relate the value of the cell potential to the feasibility of using the cell to generate an electric current',
      'Describe the electrochemistry involved in some common batteries: a. Leclanche dry cell, b. Button batteries, c. Fuel cells',
   ]),
};

export const CN_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'conventions_of_different_genre',
         label: 'Conventions of Different Genre',
         start: 1,
         count: 10,
         mean: 5.9,
         stdDev: 1.37,
         ranges: [
            [0, 5.21, 'Beginner'],
            [5.22, 6.59, 'Basic'],
            [6.6, 10, 'Competent'],
         ],
      },
      {
         key: 'nonfiction_types_and_forms',
         label: 'Nonfiction Types and Forms',
         start: 11,
         count: 10,
         mean: 5.13,
         stdDev: 1.7,
         ranges: [
            [0, 4.27, 'Beginner'],
            [4.28, 5.98, 'Basic'],
            [5.99, 10, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 8.9, 'Beginner'],
      [8.91, 11.15, 'Basic'],
      [11.16, 20, 'Competent'],
   ],
   sections: [
      { label: 'A. Conventions of Different Genre', start: 1, end: 10 },
      { label: 'B. Nonfiction Types and Forms', start: 11, end: 20 },
   ],
   competencies: toCompetencies([
      'Analyze factual/nonfictional elements (Plot, Characters, Characterization, Point of View, Angle, Setting and Atmosphere, Symbols and Symbolisms, Irony, Figures of speech, Dialogue, Scene, Other elements and Devices) in the texts',
      'Analyze factual/nonfictional elements (Plot, Characters, Characterization, Point of View, Angle, Setting and Atmosphere, Symbols and Symbolisms, Irony, Figures of speech, Dialogue, Scene, Other elements and Devices) in the texts',
      'Analyze factual/nonfictional elements (Plot, Characters, Characterization, Point of View, Angle, Setting and Atmosphere, Symbols and Symbolisms, Irony, Figures of speech, Dialogue, Scene, Other elements and Devices) in the texts',
      'Analyze factual/nonfictional elements (Plot, Characters, Characterization, Point of View, Angle, Setting and Atmosphere, Symbols and Symbolisms, Irony, Figures of speech, Dialogue, Scene, Other elements and Devices) in the texts',
      'Analyze factual/nonfictional elements (Plot, Characters, Characterization, Point of View, Angle, Setting and Atmosphere, Symbols and Symbolisms, Irony, Figures of speech, Dialogue, Scene, Other elements and Devices) in the texts',
      'Evaluate a draft based on: clarity of idea, appropriate choice of literary element, appropriate use of the element, effective combination of the idea and the chosen, and literary element',
      'Evaluate a draft based on: clarity of idea, appropriate choice of literary element, appropriate use of the element, effective combination of the idea and the chosen, and literary element',
      'Evaluate a draft based on: clarity of idea, appropriate choice of literary element, appropriate use of the element, effective combination of the idea and the chosen, and literary element',
      'Evaluate a draft based on: clarity of idea, appropriate choice of literary element, appropriate use of the element, effective combination of the idea and the chosen, and literary element',
      'Evaluate a draft based on: clarity of idea, appropriate choice of literary element, appropriate use of the element, effective combination of the idea and the chosen, and literary element',
      'Present a commentary/critique on a chosen creative nonfictional text representing a particular type or form (Biography/Autobiography, Literary Journalism/Reportage, Personal Narratives, Travelogue, Reflection Essay, True Narratives, Blogs, Testimonies, Other Forms)',
      'Present a commentary/critique on a chosen creative nonfictional text representing a particular type or form (Biography/Autobiography, Literary Journalism/Reportage, Personal Narratives, Travelogue, Reflection Essay, True Narratives, Blogs, Testimonies, Other Forms)',
      'Present a commentary/critique on a chosen creative nonfictional text representing a particular type or form (Biography/Autobiography, Literary Journalism/Reportage, Personal Narratives, Travelogue, Reflection Essay, True Narratives, Blogs, Testimonies, Other Forms)',
      'Present a commentary/critique on a chosen creative nonfictional text representing a particular type or form (Biography/Autobiography, Literary Journalism/Reportage, Personal Narratives, Travelogue, Reflection Essay, True Narratives, Blogs, Testimonies, Other Forms)',
      'Present a commentary/critique on a chosen creative nonfictional text representing a particular type or form (Biography/Autobiography, Literary Journalism/Reportage, Personal Narratives, Travelogue, Reflection Essay, True Narratives, Blogs, Testimonies, Other Forms)',
      'Present a commentary/critique on a chosen creative nonfictional text representing a particular type or form (Biography/Autobiography, Literary Journalism/Reportage, Personal Narratives, Travelogue, Reflection Essay, True Narratives, Blogs, Testimonies, Other Forms)',
      'Present a commentary/critique on a chosen creative nonfictional text representing a particular type or form (Biography/Autobiography, Literary Journalism/Reportage, Personal Narratives, Travelogue, Reflection Essay, True Narratives, Blogs, Testimonies, Other Forms)',
      'Present a commentary/critique on a chosen creative nonfictional text representing a particular type or form (Biography/Autobiography, Literary Journalism/Reportage, Personal Narratives, Travelogue, Reflection Essay, True Narratives, Blogs, Testimonies, Other Forms)',
      'Present a commentary/critique on a chosen creative nonfictional text representing a particular type or form (Biography/Autobiography, Literary Journalism/Reportage, Personal Narratives, Travelogue, Reflection Essay, True Narratives, Blogs, Testimonies, Other Forms)',
      'Present a commentary/critique on a chosen creative nonfictional text representing a particular type or form (Biography/Autobiography, Literary Journalism/Reportage, Personal Narratives, Travelogue, Reflection Essay, True Narratives, Blogs, Testimonies, Other Forms)',
   ]),
};

export const CWG12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'figures_of_speech',
         label: 'Figures of Speech',
         start: 1,
         count: 4,
         mean: 2.14,
         stdDev: 1.07,
         ranges: [
            [0, 1.6, 'Beginner'],
            [1.61, 2.68, 'Basic'],
            [2.69, 4, 'Competent'],
         ],
      },
      {
         key: 'poetry',
         label: 'Poetry',
         start: 5,
         count: 5,
         mean: 3.08,
         stdDev: 1.42,
         ranges: [
            [0, 2.31, 'Beginner'],
            [2.32, 3.74, 'Basic'],
            [3.75, 5, 'Competent'],
         ],
      },
      {
         key: 'fiction',
         label: 'Fiction',
         start: 10,
         count: 6,
         mean: 3.07,
         stdDev: 1.67,
         ranges: [
            [0, 2.23, 'Beginner'],
            [2.24, 3.91, 'Basic'],
            [3.92, 10, 'Competent'],
         ],
      },
      {
         key: 'drama',
         label: 'Drama',
         start: 16,
         count: 15,
         mean: 9.94,
         stdDev: 3.84,
         ranges: [
            [0, 8.01, 'Beginner'],
            [8.02, 11.86, 'Basic'],
            [11.87, 15, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 15.17, 'Beginner'],
      [15.18, 21.81, 'Basic'],
      [21.82, 30, 'Competent'],
   ],
   sections: [
      { label: 'A. Figures of Speech', start: 1, end: 4 },
      { label: 'B. Poetry', start: 5, end: 9 },
      { label: 'C. Fiction', start: 10, end: 15 },
      { label: 'D. Drama', start: 16, end: 30 },
   ],
   competencies: toCompetencies([
      'Use imagery, diction, figures of speech, and specific experiences to evoke meaningful responses from readers',
      'Use imagery, diction, figures of speech, and specific experiences to evoke meaningful responses from readers',
      'Use imagery, diction, figures of speech, and specific experiences to evoke meaningful responses from readers',
      'Use imagery, diction, figures of speech, and specific experiences to evoke meaningful responses from readers',
      'Identify the various elements, techniques, and literary devices in specific forms of poetry',
      'Identify the various elements, techniques, and literary devices in specific forms of poetry',
      'Identify the various elements, techniques, and literary devices in specific forms of poetry',
      'Identify the various elements, techniques, and literary devices in specific forms of poetry',
      'Identify the various elements, techniques, and literary devices in specific forms of poetry',
      'Identify the various elements, techniques, and literary devices in various modes of fiction',
      'Identify the various elements, techniques, and literary devices in various modes of fiction',
      'Identify the various elements, techniques, and literary devices in various modes of fiction',
      'Identify the various elements, techniques, and literary devices in various modes of fiction',
      'Identify the various elements, techniques, and literary devices in various modes of fiction',
      'Identify the various elements, techniques, and literary devices in various modes of fiction',
      'Identify the various elements, techniques, and literary devices in drama',
      'Identify the various elements, techniques, and literary devices in drama',
      'Identify the various elements, techniques, and literary devices in drama',
      'Identify the various elements, techniques, and literary devices in drama',
      'Identify the various elements, techniques, and literary devices in drama',
      'Identify the various elements, techniques, and literary devices in drama',
      'Identify the various elements, techniques, and literary devices in drama',
      'Identify the various elements, techniques, and literary devices in drama',
      'Understand intertextuality as a technique of drama',
      'Understand intertextuality as a technique of drama',
      'Understand intertextuality as a technique of drama',
      'Understand intertextuality as a technique of drama',
      'Understand intertextuality as a technique of drama',
      'Understand intertextuality as a technique of drama',
      'Understand intertextuality as a technique of drama',
   ]),
};

export const DIASS12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'counseling',
         label: 'Counseling',
         start: 1,
         count: 12,
         mean: 1.27,
         stdDev: 0.79,
         ranges: [
            [0, 6.92, 'Beginner'],
            [6.93, 9.31, 'Basic'],
            [9.32, 12, 'Competent'],
         ],
      },
      {
         key: 'social_work',
         label: 'Social Work',
         start: 13,
         count: 9,
         mean: 1.27,
         stdDev: 0.79,
         ranges: [
            [0, 5.92, 'Beginner'],
            [5.93, 7.86, 'Basic'],
            [7.87, 9, 'Competent'],
         ],
      },
      {
         key: 'communication',
         label: 'Communication',
         start: 22,
         count: 11,
         mean: 1.27,
         stdDev: 0.79,
         ranges: [
            [0, 6.49, 'Beginner'],
            [6.5, 9.01, 'Basic'],
            [9.02, 11, 'Competent'],
         ],
      },
      {
         key: 'applied_social_science',
         label: 'Applied Social Science',
         start: 33,
         count: 3,
         mean: 1.27,
         stdDev: 0.79,
         ranges: [
            [0, 1, 'Beginner'],
            [1.01, 2, 'Basic'],
            [2.01, 3, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 15.08, 'Beginner'],
      [15.09, 17.23, 'Basic'],
      [17.24, 35, 'Competent'],
   ],
   sections: [
      { label: 'A. Counseling', start: 1, end: 12 },
      { label: 'B. Social Work', start: 13, end: 21 },
      { label: 'C. Communication', start: 22, end: 32 },
      { label: 'D. Applied Social Sciences', start: 33, end: 35 },
   ],
   competencies: toCompetencies([
      'Identify the goals and scope of counseling',
      'Explain the principles of counseling',
      'Explain the principles of counseling',
      'Discuss roles and functions of counselors',
      'Identify specific work areas in which counselors work',
      'Identify specific work areas in which counselors work',
      'Value rights, responsibilities, and accountabilities of counselors',
      'Distinguish between ethical and unethical behaviors among counselors',
      'Describe the clientele of counseling',
      'Illustrate the different processes and methods involved in counseling',
      'Illustrate the different processes and methods involved in counseling',
      'Distinguish the needs of individuals, groups, organizations, and communities',
      'Identify the goals and scope of social work',
      'Explain the principles and core values of social work',
      'Explain the roles and functions of social workers',
      'Identify specific work areas in which social workers work',
      'Value rights, responsibilities, and accountabilities',
      'Distinguish between ethical and unethical behaviors among practitioners',
      'Describe the clientele of social work',
      'Distinguish the needs of individuals, groups, organizations and communities',
      'Illustrate the different processes and methods involved in undertaking social work',
      'Identify the goals and scope of communication',
      'Explain the principles of communication',
      'Describe the elements and levels of the communication processes',
      'Explain the roles and functions of communicators and journalists',
      'Identify specific work areas in which communicators and journalists work',
      'Explain the rights, responsibilities, and accountabilities',
      'Distinguish between ethical and unethical behaviors among practitioners',
      'Describe the clientele and audience of communication',
      'Distinguish the needs of individuals, groups, organizations, and communities',
      'Illustrate the different processes and methods involved in undertaking communication',
      'Distinguish the appropriate communication media channel(s) to use in different settings and situations',
      'Explain each of the functions of applied social science',
      'Identify situations that would require or necessitate the performance of the various functions in local /Philippine settings',
      'Evaluate the effects of certain program or projects on knowledge, attitude, and behavior of individuals, groups, and society',
   ]),
};

export const DRR_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'concept_of_disaster',
         label: 'Concept of Disaster',
         start: 1,
         count: 7,
         mean: 4,
         stdDev: 1.2,
         ranges: [
            [0, 3.35, 'Beginner'],
            [3.36, 6.11, 'Basic'],
            [6.12, 7, 'Competent'],
         ],
      },
      {
         key: 'exposure_and_vulnerability',
         label: 'Exposure and Vulnerability',
         start: 8,
         count: 8,
         mean: 5.2,
         stdDev: 1.2,
         ranges: [
            [0, 2.53, 'Beginner'],
            [2.54, 5.43, 'Basic'],
            [5.44, 8, 'Competent'],
         ],
      },
      {
         key: 'concept_of_hazard',
         label: 'Concept of Hazard',
         start: 16,
         count: 5,
         mean: 3.1,
         stdDev: 1.2,
         ranges: [
            [0, 1.55, 'Beginner'],
            [1.56, 3.89, 'Basic'],
            [3.9, 5, 'Competent'],
         ],
      },
      {
         key: 'earthquake_hazard',
         label: 'Earthquake Hazard',
         start: 21,
         count: 9,
         mean: 5.8,
         stdDev: 1.2,
         ranges: [
            [0, 4.83, 'Beginner'],
            [4.84, 8.34, 'Basic'],
            [8.35, 9, 'Competent'],
         ],
      },
      {
         key: 'volcano_hazard',
         label: 'Volcano Hazard',
         start: 30,
         count: 5,
         mean: 3.2,
         stdDev: 1.2,
         ranges: [
            [0, 1.41, 'Beginner'],
            [1.42, 3.6, 'Basic'],
            [3.61, 5, 'Competent'],
         ],
      },
      {
         key: 'other_geologic_hazards',
         label: 'Other Geologic Hazards',
         start: 35,
         count: 5,
         mean: 3.2,
         stdDev: 1.2,
         ranges: [
            [0, 2.11, 'Beginner'],
            [2.12, 4.62, 'Basic'],
            [4.63, 5, 'Competent'],
         ],
      },
      {
         key: 'hydrometeorological_hazards',
         label: 'Hydrometeorological Hazards',
         start: 40,
         count: 7,
         mean: 4,
         stdDev: 1.2,
         ranges: [
            [0, 2.08, 'Beginner'],
            [2.09, 4.73, 'Basic'],
            [4.74, 7, 'Competent'],
         ],
      },
      {
         key: 'fire_hazards',
         label: 'Fire Hazards',
         start: 47,
         count: 7,
         mean: 4,
         stdDev: 1.2,
         ranges: [
            [0, 3.65, 'Beginner'],
            [3.66, 6.32, 'Basic'],
            [6.33, 7, 'Competent'],
         ],
      },
      {
         key: 'disaster_risk_reduction',
         label: 'Disaster Risk Reduction',
         start: 54,
         count: 2,
         mean: 1,
         stdDev: 0.9,
         ranges: [
            [0, 0.23, 'Beginner'],
            [0.24, 1.28, 'Basic'],
            [1.29, 2, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 25.86, 'Beginner'],
      [25.87, 38.52, 'Basic'],
      [38.53, 55, 'Competent'],
   ],
   sections: [
      { label: 'A. Concepts of Disaster', start: 1, end: 7 },
      { label: 'B. Exposure and Vulnerability', start: 8, end: 15 },
      { label: 'C. Concept of Hazard', start: 16, end: 20 },
      { label: 'D. Earthquake Hazard', start: 21, end: 29 },
      { label: 'E. Volcano Hazard', start: 30, end: 34 },
      { label: 'F. Other Geologic Hazards', start: 35, end: 39 },
      { label: 'G. Hydrometeorological Hazards', start: 40, end: 46 },
      { label: 'H. Fire Hazards', start: 47, end: 53 },
      { label: 'I. Disaster Risk Reduction', start: 54, end: 55 },
   ],
   competencies: toCompetencies([
      'Explain the meaning of disaster.',
      'Differentiate the risk factors underlying disasters.',
      'Describe the effects of disasters on one’s life.',
      'Explain how and when an event becomes a disaster.',
      'Identify areas/locations exposed to hazards that may lead to disasters.',
      'Explain disaster from the different perspectives (physical, psychological, socio-cultural, economic, political, and biological).',
      'Explain disaster from the different perspectives (physical, psychological, socio-cultural, economic, political, and biological).',
      'Explain the meaning of vulnerability.',
      'Explain why certain sectors of society are more vulnerable to disaster than others.',
      'Give reason why certain structures are more vulnerable to specific hazards than others.',
      'Give reason why certain structures are more vulnerable to specific hazards than others.',
      'Determine the elements that are exposed to a particular hazard.',
      'Recognize vulnerabilities of different elements exposed to specific hazards.',
      'Recognize vulnerabilities of different elements exposed to specific hazards.',
      'Differentiate among hazards, exposure, and vulnerabilities and give examples from actual situations.',
      'Define hazards.',
      'Give examples of the types of hazards.',
      'Give examples of the types of hazards.',
      'Explain the impact of various hazards on different exposed elements.',
      'Explain the impact of various hazards on different exposed elements.',
      'Identify various potential earthquake hazards.',
      'Identify various potential earthquake hazards.',
      'Recognize the natural signs of an impending tsunami.',
      'Identify the effects of the different earthquake hazards.',
      'Identify the effects of the different earthquake hazards.',
      'Interpret different earthquake hazard maps.',
      'Interpret different earthquake hazard maps.',
      'Apply precautionary and safety measures before, during, and after an earthquake.',
      'Apply precautionary and safety measures before, during, and after an earthquake.',
      'Explain various volcano-related hazards.',
      'Recognize signs of an impending volcanic eruption.',
      'Interpret different volcano hazard maps.',
      'Interpret different volcano hazard maps.',
      'Apply appropriate measures/interventions before, during, and after a volcanic eruption',
      'Identify the causes of geological hazards',
      'Recognize signs of impending geological hazards.',
      'Interpret geological maps.',
      'Interpret geological maps.',
      'Use mitigation strategies to prevent loss of lives and properties.',
      'Distinguish and differentiate among and between different hydrometeorological hazards.',
      'Recognize signs of impending hydrometeorological hazards.',
      'Apply appropriate measures/interventions before, during, and after hydrometeorological hazards.',
      'Apply appropriate measures/interventions before, during, and after hydrometeorological hazards.',
      'Interpret different hydrometeorological hazard maps.',
      'Interpret different hydrometeorological hazard maps.',
      'Use available tools for monitoring hydro-meteorological hazards.',
      'Recognize elements of the fire triangle in different situations.',
      'Identify situation that would cause fire.',
      'Identify situation that would cause fire.',
      'Observe precautionary measures and proper procedures in addressing a fire incident.',
      'Observe precautionary measures and proper procedures in addressing a fire incident.',
      'Apply basic response procedures during a fire incident.',
      'Follow fire emergency and evacuation plans.',
      'Recognize the importance of DRR on one’s life.',
      'Explain DRR-related laws and policies.',
   ]),
};

export const DSS_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'conic_sections',
         label: 'Conic Sections',
         start: 1,
         count: 13,
         mean: 6.43,
         stdDev: 1.83,
         ranges: [
            [0, 5.51, 'Beginner'],
            [5.52, 7.35, 'Basic'],
            [7.36, 13, 'Competent'],
         ],
      },
      {
         key: 'binomial_theorem',
         label: 'Binomial Theorem',
         start: 14,
         count: 8,
         mean: 4.54,
         stdDev: 1.39,
         ranges: [
            [0, 3.84, 'Beginner'],
            [3.85, 5.24, 'Basic'],
            [5.25, 8, 'Competent'],
         ],
      },
      {
         key: 'circular_functions',
         label: 'Circular Functions',
         start: 22,
         count: 19,
         mean: 9.27,
         stdDev: 1.88,
         ranges: [
            [0, 8.32, 'Beginner'],
            [8.33, 10.21, 'Basic'],
            [10.22, 19, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 18.72, 'Beginner'],
      [18.73, 22.61, 'Basic'],
      [22.62, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Conic Sections', start: 1, end: 13 },
      { label: 'B. Binomial Theorem', start: 14, end: 21 },
      { label: 'C. Circular Functions', start: 22, end: 40 },
   ],
   competencies: toCompetencies([
      'Illustrate the different types of conic sections: parabola, ellipse, circle, hyperbola, and degenerate cases.',
      'Define a circle.',
      'Determine the standard form of equation of a circle.',
      'Define a parabola',
      'Determine the standard form of equation of a parabola',
      'Define an ellipse',
      'Determine the standard form of equation of an ellipse',
      'Define a hyperbola',
      'Determine the standard form of equation of a hyperbola',
      'Recognize the equation and important characteristics of the different types of conic sections',
      'Recognize the equation and important characteristics of the different types of conic sections',
      'Solves situational problems involving conic sections',
      'Solves situational problems involving conic sections',
      'Illustrate a series',
      'Illustrate a series',
      'Differentiate a series from a sequence',
      'Differentiate a series from a sequence',
      'Use the sigma notation to represent a series',
      'Use the sigma notation to represent a series',
      'Apply the use of sigma notation in finding sums',
      'Apply the use of sigma notation in finding sums',
      'Illustrate the unit circle and the relationship between the linear and angular measures of a central angle in a unit circle',
      'Convert degree measure to radian measure and vice versa',
      'Illustrate angles in standard position and coterminal angles',
      'Illustrate the different circular functions',
      'Uses reference angles to find exact values of circular functions',
      'Illustrate the domain and range of the different circular functions',
      'Graph the six circular functions (a) amplitude, (b) period, and (c) phase shift',
      'Solve situational problems involving circular functions',
      'Solve situational problems involving circular functions',
      'Determine whether an equation is an identity or a conditional equation',
      'Apply trigonometric identities to find other trigonometric values',
      'Solve situational problems involving trigonometric identities',
      'Solve situational problems involving trigonometric identities',
      'Illustrate the domain and range of the inverse trigonometric functions.',
      'Evaluate an inverse trigonometric expression',
      'Solve trigonometric equations.',
      'Solve trigonometric equations.',
      'Solve situational problems involving inverse trigonometric functions and trigonometric equations',
      'Solve situational problems involving inverse trigonometric functions and trigonometric equations',
   ]),
};

export const ELS_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'origin_and_structure_of_the_earth',
         label: 'Origin and Structure of the Earth',
         start: 1,
         count: 8,
         mean: 3.92,
         stdDev: 1.38,
         ranges: [
            [0, 2.53, 'Beginner'],
            [2.54, 5.3, 'Basic'],
            [5.31, 8, 'Competent'],
         ],
      },
      {
         key: 'earth_materials_and_processes',
         label: 'Earth Materials and Processes',
         start: 9,
         count: 20,
         mean: 10.08,
         stdDev: 3.48,
         ranges: [
            [0, 6.59, 'Beginner'],
            [6.6, 13.56, 'Basic'],
            [13.57, 20, 'Competent'],
         ],
      },
      {
         key: 'natural_hazards_mitigation_and_adaptation',
         label: 'Natural Hazards, Mitigation, and Adaptation',
         start: 29,
         count: 12,
         mean: 9.46,
         stdDev: 2.52,
         ranges: [
            [0, 6.93, 'Beginner'],
            [6.94, 11.74, 'Basic'],
            [11.75, 12, 'Competent'],
         ],
      },
      {
         key: 'origin_of_life',
         label: 'Origin of Life',
         start: 41,
         count: 1,
         mean: 0.33,
         stdDev: 0.48,
         ranges: [
            [0, 0.14, 'Beginner'],
            [0.15, 0.81, 'Basic'],
            [0.82, 1, 'Competent'],
         ],
      },
      {
         key: 'biogenerics',
         label: 'Biogenerics',
         start: 41,
         count: 1,
         mean: 2.33,
         stdDev: 0.76,
         ranges: [
            [0, 0.14, 'Beginner'],
            [0.15, 0.81, 'Basic'],
            [0.82, 1, 'Competent'],
         ],
      },
      {
         key: 'perpetuation_of_life',
         label: 'Perpetuation of Life',
         start: 42,
         count: 9,
         mean: 3.63,
         stdDev: 0.71,
         ranges: [
            [0, 2.91, 'Beginner'],
            [2.92, 4.34, 'Basic'],
            [4.35, 9, 'Competent'],
         ],
      },
      {
         key: 'how_animals_survive',
         label: 'How Animals Survive',
         start: 51,
         count: 3,
         mean: 2.25,
         stdDev: 0.61,
         ranges: [
            [0, 1.63, 'Beginner'],
            [1.64, 2.86, 'Basic'],
            [2.87, 3, 'Competent'],
         ],
      },
      {
         key: 'how_plants_survive',
         label: 'How Plants Survive',
         start: 54,
         count: 2,
         mean: 0.75,
         stdDev: 0.81,
         ranges: [
            [0, 0.09, 'Beginner'],
            [0.1, 1.6, 'Basic'],
            [1.61, 2, 'Competent'],
         ],
      },
      {
         key: 'the_process_of_evolution',
         label: 'The Process of Evolution',
         start: 56,
         count: 3,
         mean: 2.17,
         stdDev: 0.76,
         ranges: [
            [0, 1.34, 'Beginner'],
            [1.35, 2.87, 'Basic'],
            [2.88, 3, 'Competent'],
         ],
      },
      {
         key: 'ecosystem_interaction_and_interdependence',
         label: 'Ecosystem: Interaction and Interdependence',
         start: 59,
         count: 2,
         mean: 1.42,
         stdDev: 0.65,
         ranges: [
            [0, 0.76, 'Beginner'],
            [0.77, 1.5, 'Basic'],
            [1.51, 2, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 30.95, 'Beginner'],
      [30.96, 41.7, 'Basic'],
      [41.71, 60, 'Competent'],
   ],
   sections: [
      { label: 'A. Origin and Structure of the Earth', start: 1, end: 8 },
      { label: 'B. Earth Materials and Processes', start: 9, end: 28 },
      {
         label: 'C. Natural Hazards, Mitigation, and Adaptation',
         start: 29,
         end: 40,
      },
      { label: 'D. Origin of Life', start: 41, end: 41 },
      { label: 'E. Biogenerics', start: 42, end: 45 },
      { label: 'F. Perpetuation of Life', start: 46, end: 50 },
      { label: 'G. How Animals Survive', start: 51, end: 53 },
      { label: 'H. How Plants Survive', start: 54, end: 55 },
      { label: 'I. The Process of Evolution', start: 56, end: 58 },
      {
         label: 'J. Ecosystem: Interaction and Interdependence',
         start: 59,
         end: 60,
      },
   ],
   competencies: toCompetencies([
      'State the different hypotheses explaining the origin of the universe.',
      'Describe the different hypotheses explaining the origin of the solar system.',
      'Recognize the uniqueness of Earth, being the only planet in the solar system with properties necessary to support life.',
      'Explain that the Earth consists of four subsystems, across whose boundaries matter and energy flow.',
      'Explain the current advancements/information on the solar system.',
      'Show the contributions of personalities/people on theunderstanding of the earth systems.',
      'Identify the layers of the Earth (crust, mantle, core).',
      'Differentiate the layers of the Earth.',
      'Identify common rock-forming minerals using their physical and chemical properties.',
      'Classify rocks into igneous, sedimentary, and metamorphic.',
      'Describe how rocks undergo weathering.',
      'Explain how the products of weathering are carried away by erosion and deposited elsewhere.',
      'Describe where the Earth’s internal heat comes from.',
      'Describe how magma is formed (magmatism).',
      'Describe what happens after the magma is formed (plutonism and volcanism).',
      'Describe the changes in mineral components and texture of rocks due to changes in pressure and temperature (metamorphism).',
      'Compare and contrast the formation of the different types of igneous rocks.',
      'Describe how rocks behave under different types of stress such as compression, pulling apart, and shearing.',
      'Explain how the continents drift.',
      'Cite evidence that support continental drift.',
      'Explain how the movement of plates leads to the formation of folds and faults.',
      'Explain how the seafloor spreads.',
      'Describe the structure and evolution of ocean basins.',
      'Describe how layers of rocks (stratified rocks) are formed.',
      'Describe the different methods (relative and absolute dating) to determine the age of stratified rocks.',
      'Explain how relative and absolute dating were used to determine the subdivisions of geologic time.',
      'Describe how marker fossils (also known as guide fossils) are used to define and identify subdivisions of the geologic time scale.',
      'Describe how the Earth’s history can be interpreted from the geologic time scale.',
      'Describe the various hazards that may happen in the event of earthquakes, volcanic eruptions, and landslides.',
      'Using hazard maps, identify areas prone to hazards brought about by earthquakes, volcanic eruptions, and landslides.',
      'Give practical ways of coping with geological hazards caused by earthquakes, volcanic eruptions, and landslides.',
      'Identify human activities that speed up or trigger landslides.',
      'Suggest ways to help lessen the occurrence of landslides in your community.',
      'Describe the various hazards that may happen in the wake of tropical cyclones, monsoons, floods, or ipo-ipo.',
      'Using hazard maps, identify areas prone to hazards brought about by tropical cyclones, monsoons, floods, or ipo-ipo.',
      'Give practical ways of coping with hydrometeorological hazards caused by tropical cyclones, monsoons, floods, or ipo-ipo.',
      'Describe how coastal processes result in coastal erosion, submersion, and saltwater intrusion.',
      'Identify areas in your community prone to coastal erosion, submersion, and saltwater intrusion.',
      'Give practical ways of coping with coastal erosion, submersion, and saltwater intrusion.',
      'Cite ways to prevent or mitigate the impact of land development, waste disposal, and construction of structures on control coastal processes.',
      'Explain the evolving concept of life based on emerging pieces of evidence.',
      'Explain how cells carry out functions required for life.',
      'Explain how photosynthetic organisms use light energy to combine carbon dioxide and water to form energy-rich compounds.',
      'Trace the energy flow from the environment to the cells.',
      'Describe how organisms obtain and utilize energy.',
      'Describe the different ways of how plants reproduce.',
      'Describe the different ways of how representative animals reproduce.',
      'Explain how the information in the DNA allows the transfer of genetic information and synthesis of proteins.',
      'Describe the process of genetic engineering.',
      'Evaluate the benefits and risks of using GMOs.',
      'Explain the different metabolic processes involved in the various organ systems.',
      'Describe the general and unique characteristics of the different organ systems in representative animals.',
      'Analyze and appreciate the functional relationships of the different organ systems in ensuring animal survival.',
      'Describe the structure and function of the different plant organs.',
      'Explain the different metabolic processes involved in the plant organ systems.',
      'Describe evidence of evolution such as homology, DNA/protein sequences, plate tectonics, fossil record, embryology, and artificial selection/agriculture.',
      'Explain how populations of organisms have changed and continue to change over time showing patterns of descent with modification from common ancestors to produce the organismal diversity observed today.',
      'Describe how the present system of classification of organisms is based on evolutionary relationships.',
      'Describe the principles of the ecosystem.',
      'Describe how the different terrestrial and aquatic ecosystems are interlinked with one another.',
   ]),
};

export const FABM1_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'nature_of_accounting',
         label: 'Nature of Accounting',
         start: 1,
         count: 10,
         mean: 5.38,
         stdDev: 1.71,
         ranges: [
            [0, 4.52, 'Beginner'],
            [4.52, 6.24, 'Basic'],
            [6.25, 10, 'Competent'],
         ],
      },
      {
         key: 'major_accounts_and_transactions',
         label: 'Major Accounts and Transactions',
         start: 11,
         count: 15,
         mean: 7.11,
         stdDev: 2.12,
         ranges: [
            [0, 6.04, 'Beginner'],
            [6.05, 8.17, 'Basic'],
            [8.18, 15, 'Competent'],
         ],
      },
      {
         key: 'the_accounting_cycle',
         label: 'The Accounting Cycle',
         start: 26,
         count: 15,
         mean: 7.64,
         stdDev: 1.91,
         ranges: [
            [0, 6.68, 'Beginner'],
            [6.69, 8.6, 'Basic'],
            [8.61, 15, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 19.29, 'Beginner'],
      [19.3, 22.96, 'Basic'],
      [22.97, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Nature of Accounting', start: 1, end: 10 },
      { label: 'B. Major Accounts and Transactions', start: 11, end: 25 },
      { label: 'C. The Accounting Cycle', start: 26, end: 40 },
   ],
   competencies: toCompetencies([
      'Define accounting',
      'Describe the nature of accounting',
      'Narrate the history/origin of accounting',
      'Define external users and gives examples',
      'Define internal users and give examples',
      'Explain the varied accounting concepts and principles',
      'Explain the varied accounting concepts and principles',
      'illustrate the accounting equation',
      'Perform operations involving simple cases with the use of accounting equation',
      'Perform operations involving simple cases with the use of accounting equation',
      'Discuss the five major accounts',
      'Prepare a Chart of Accounts',
      'Illustrate the format of a general and special journals',
      'Illustrate the format of a general and subsidiary ledger',
      'Analyze common business transactions using the rules of debit and credit',
      'Solve simple problems and exercises in the analyses of business transaction',
      'Solve simple problems and exercises in the analyses of business transaction',
      'Describes the nature of transactions in a service business',
      'Records transactions of a service business in the general journal',
      'Posts transactions in the ledger',
      'Prepares a trial balance',
      'Prepares a trial balance',
      'Prepares adjusting entries',
      'Prepares adjusting entries',
      'Complete the accounting cycle',
      'Describes the nature of transactions in a merchandising business',
      'Records transactions of a merchandising business in the general and special journals',
      'Posts transactions in the general and subsidiary ledgers',
      'Posts transactions in the general and subsidiary ledgers',
      'Posts transactions in the general and subsidiary ledgers',
      'Prepares a trial balance',
      'Prepares a trial balance',
      'Prepares adjusting entries',
      'Prepares adjusting entries',
      'Prepares adjusting entries',
      'Prepares adjusting entries',
      'Completes the accounting cycle of a merchandising business',
      'Completes the accounting cycle of a merchandising business',
      'Prepares the Statement of Cost of Goods Sold and Gross Profit',
      'Prepares the Statement of Cost of Goods Sold and Gross Profit',
   ]),
};

export const FABM2G12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'account_titles',
         label: 'Account Titles',
         start: 1,
         count: 4,
         mean: 2.3,
         stdDev: 1.78,
         ranges: [
            [0, 1.81, 'Beginner'],
            [1.82, 3.6, 'Basic'],
            [3.61, 4, 'Competent'],
         ],
      },
      {
         key: 'service_income_operating_expenses_and_cfs',
         label: 'Service Income, Operating Expenses, and CFS',
         start: 5,
         count: 12,
         mean: 6.2,
         stdDev: 1.81,
         ranges: [
            [0, 6.19, 'Beginner'],
            [6.2, 8.01, 'Basic'],
            [8.02, 12, 'Competent'],
         ],
      },
      {
         key: 'financial_statement_bank_accounts_and_taxation',
         label: 'Financial Statement, Bank Accounts, and Taxation',
         start: 17,
         count: 24,
         mean: 13.02,
         stdDev: 2.85,
         ranges: [
            [0, 13.01, 'Beginner'],
            [13.02, 15.87, 'Basic'],
            [15.88, 24, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 21.02, 'Beginner'],
      [21.03, 25.04, 'Basic'],
      [25.05, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Account Titles', start: 1, end: 4 },
      {
         label: 'B. Service Income, Operating Expenses, and CFS',
         start: 5,
         end: 16,
      },
      {
         label: 'C. Financial Statement, Bank Accounts, and Taxation',
         start: 17,
         end: 40,
      },
   ],
   competencies: toCompetencies([
      'Identify the elements of the SFP and describe each of them',
      'Identify the elements of the SFP and describe each of them',
      'Prepare an SFP using the report form and the account form with proper classification of items as current and Noncurrent',
      'Prepare an SFP using the report form and the account form with proper classification of items as current and Noncurrent',
      'Identify the elements of the SCI and describe each of these items for a service business and a merchandising business',
      'Identify the elements of the SCI and describe each of these items for a service business and a merchandising business',
      'Prepare an SCI for a service business using the single-step approach',
      'Prepare an SCI for a service business using the single-step approach',
      'Prepare an SCI for a merchandising business using the multistep approach',
      'Prepare an SCI for a merchandising business using the multistep approach',
      'Prepare an SCE for a single proprietorship',
      'Prepare an SCE for a single proprietorship',
      'Discuss the components and structures of a CFS',
      'Discuss the components and structures of a CFS',
      'Prepare a CFS',
      'Prepare a CFS',
      'Define the measurement levels, namely, liquidity, solvency, stability, and profitability',
      'Define the measurement levels, namely, liquidity, solvency, stability, and profitability',
      'Perform vertical and horizontal analyses of financial statements of a single proprietorship',
      'Compute and interpret financial ratios such as current ratio, working capital, gross profit ratio, net profit ratio, receivable turnover, inventory turnover, debt-to-equity ratio, and the like',
      'Compute and interpret financial ratios such as current ratio, working capital, gross profit ratio, net profit ratio, receivable turnover, inventory turnover, debt-to-equity ratio, and the like',
      'Identify the types of bank accounts normally maintained by a business',
      'Identify the types of bank accounts normally maintained by a business',
      'Prepare bank deposit and withdrawal slips',
      'Prepare bank deposit and withdrawal slips',
      'Identify and prepare checks',
      'Identify and prepare checks',
      'Identify and understand the contents of a bank statement',
      'Identify and understand the contents of a bank statement',
      'Describe the nature of a bank reconciliation statement',
      'Describe the nature of a bank reconciliation statement',
      'Analyze the effects of the identified reconciling items',
      'Analyze the effects of the identified reconciling items',
      'Prepare a bank reconciliation statement',
      'Prepare a bank reconciliation statement',
      'Define income and business taxation and its principles and processes',
      'Define income and business taxation and its principles and processes',
      'Explain the procedure in the computation of gross taxable income and tax due',
      'Explain the procedure in the computation of gross taxable income and tax due',
      'Explain the principles and purposes of taxation',
   ]),
};

export const GB2G12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'recombinant_dna',
         label: 'Recombinant DNA',
         start: 1,
         count: 5,
         mean: 2.48,
         stdDev: 1,
         ranges: [
            [0, 1.97, 'Beginner'],
            [1.98, 2.98, 'Basic'],
            [2.99, 5, 'Competent'],
         ],
      },
      {
         key: 'theories_of_evolution',
         label: 'Theories of Evolution',
         start: 6,
         count: 12,
         mean: 6.48,
         stdDev: 1.69,
         ranges: [
            [0, 5.63, 'Beginner'],
            [5.64, 7.33, 'Basic'],
            [7.34, 12, 'Competent'],
         ],
      },
      {
         key: 'taxonomic_concepts',
         label: 'Taxonomic Concepts',
         start: 18,
         count: 13,
         mean: 6.7,
         stdDev: 1.86,
         ranges: [
            [0, 5.76, 'Beginner'],
            [5.77, 7.63, 'Basic'],
            [7.64, 13, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 13.77, 'Beginner'],
      [13.78, 16.8, 'Basic'],
      [16.81, 30, 'Competent'],
   ],
   sections: [
      { label: 'A. Recombinant DNA', start: 1, end: 5 },
      { label: 'B. Theories of Evolution', start: 6, end: 17 },
      { label: 'C. Taxonomic Concepts', start: 18, end: 30 },
   ],
   competencies: toCompetencies([
      'Outline the processes involved in genetic engineering',
      'Outline the processes involved in genetic engineering',
      'Discuss the applications of recombinant DNA',
      'Discuss the applications of recombinant DNA',
      'Discuss the applications of recombinant DNA',
      'Describe general features of the history of life on Earth, including generally accepted dates and sequence of the geologic time scale and characteristics of major groups of organisms present during these time periods',
      'Describe general features of the history of life on Earth, including generally accepted dates and sequence of the geologic time scale and characteristics of major groups of organisms present during these time periods',
      'Explain the mechanisms that produce change in populations from generation to generation (e.g.,artificial selection, natural selection, genetic drift, mutation, recombination)',
      'Explain the mechanisms that produce change in populations from generation to generation (e.g.,artificial selection, natural selection, genetic drift, mutation, recombination)',
      'Show patterns of descent with modification from common ancestors to produce the organismal diversity observed today',
      'Show patterns of descent with modification from common ancestors to produce the organismal diversity observed today',
      'Trace the development of evolutionary thought',
      'Trace the development of evolutionary thought',
      'Explain evidences of evolution (e.g., biogeography, fossil record, DNA/protein sequences, homology, and embryology)',
      'Explain evidences of evolution (e.g., biogeography, fossil record, DNA/protein sequences, homology, and embryology)',
      'Infer evolutionary relationships among organisms using the evidence of evolution',
      'Infer evolutionary relationships among organisms using the evidence of evolution',
      'Explain how the structural and developmental characteristics and relatedness of DNA sequences Are used in classifying living things',
      'Explain how the structural and developmental characteristics and relatedness of DNA sequences Are used in classifying living things',
      'Identify the unique/ distinctive characteristics of a specific taxon relative to other taxa',
      'Identify the unique/ distinctive characteristics of a specific taxon relative to other taxa',
      'Describe species diversity and cladistics, including the types of evidence and procedures that can be used to establish evolutionary relationships',
      'Describe species diversity and cladistics, including the types of evidence and procedures that can be used to establish evolutionary relationships',
      'Compare and contrast the following processes in plants and animals: reproduction, development, nutrition, gas exchange, transport/ circulation, regulation of body fluids, chemical and nervous control, immune systems, and sensory and motor mechanisms',
      'Compare and contrast the following processes in plants and animals: reproduction, development, nutrition, gas exchange, transport/ circulation, regulation of body fluids, chemical and nervous control, immune systems, and sensory and motor mechanisms',
      'Explain how some organisms maintain steady internal conditions (e.g., temperature regulation, osmotic balance and glucose levels) that possess various structures and processes',
      'Explain how some organisms maintain steady internal conditions (e.g., temperature regulation, osmotic balance and glucose levels) that possess various structures and processes',
      'Explain how some organisms maintain steady internal conditions (e.g., temperature regulation, osmotic balance and glucose levels) that possess various structures and processes',
      'Explain how some organisms maintain steady internal conditions (e.g., temperature regulation, osmotic balance and glucose levels) that possess various structures and processes',
      'Explain how some organisms maintain steady internal conditions (e.g., temperature regulation, osmotic balance and glucose levels) that possess various structures and processes',
   ]),
};

export const GP2G12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'electricity_and_magnetism',
         label: 'Electricity and Magnetism',
         start: 1,
         count: 25,
         mean: 12.5,
         stdDev: 2.44,
         ranges: [
            [0, 11.27, 'Beginner'],
            [11.28, 13.72, 'Basic'],
            [13.73, 25, 'Competent'],
         ],
      },
      {
         key: 'electromagnetism',
         label: 'Electromagnetism',
         start: 26,
         count: 7,
         mean: 3.55,
         stdDev: 1.2,
         ranges: [
            [0, 2.94, 'Beginner'],
            [2.95, 4.15, 'Basic'],
            [4.16, 7, 'Competent'],
         ],
      },
      {
         key: 'reflection_and_refraction',
         label: 'Reflection and Refraction',
         start: 33,
         count: 8,
         mean: 2.71,
         stdDev: 1.52,
         ranges: [
            [0, 1.94, 'Beginner'],
            [1.95, 3.47, 'Basic'],
            [3.48, 8, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 19.07, 'Beginner'],
      [19.08, 22.47, 'Basic'],
      [22.48, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Electricity and Magnetism', start: 1, end: 25 },
      { label: 'B. Electromagnetism', start: 26, end: 32 },
      { label: 'C. Reflection and Refraction', start: 33, end: 40 },
   ],
   competencies: toCompetencies([
      'Describe using a diagram charging by rubbing and charging by induction',
      'Explain the role of electron transfer in electrostatic charging by rubbing',
      'Calculate the net electric force on a point charge exerted by a system of point charges',
      'Calculate the electric field due to a system of point charges using Coulomb’s law and the superposition principle',
      'Calculate electric flux',
      'Solve problems involving electric charges, dipoles, forces, fields, and flux in contexts such as, but not limited to, systems of point charges, electrical breakdown of air, charged pendulums, electrostatic ink-jet printers',
      'Determine the electric potential function at any point due to highly symmetric continuous- charge Distributions',
      'Calculate the electric field in the region given a mathematical function describing its potential in a region of space',
      'Solve problems involving electric potential energy and electric potentials in contexts such as, but not limited to, electron guns in CRT TV picture tubes and Van de Graaff generators',
      'Calculate the equivalent capacitance of a network of capacitors connected in series/parallel',
      'Determine the total charge, the charge on, and the potential difference across each capacitor in the network given the capacitors connected in series/parallel',
      'Determine the potential energy stored inside the capacitor given the geometry and the potential difference across the capacitor',
      'Solve problems involving capacitors and dielectrics in contexts such as, but not limited to, charged plates, batteries, and camera flashlamps',
      'Describe the effect of temperature increase on the resistance of a metallic conductor',
      'Describe the ability of a material to conduct current in terms of resistivity and conductivity',
      'Differentiate ohmic and non-ohmic materials in terms of their I-V curves',
      'Given an emf source connected to a resistor, determine the power supplied or dissipated by each element in a circuit',
      'Solve problems involving current, resistivity, resistance, and Ohm’s law in contexts such as, but not limited to, batteries and bulbs, household wiring, and selection of fuses',
      'Calculate the current and voltage through and across circuit elements using Kirchhoff’s loop and junction rules (at most 2 loops only)',
      'Solve problems involving the calculation of currents and potential difference in circuits consisting of batteries, resistors and capacitors',
      'Differentiate electric interactions from magnetic interactions',
      'Describe the motion of a charged particle in a magnetic field in terms of its speed, acceleration, cyclotron radius, cyclotron frequency, and kinetic energy',
      'Calculate the magnetic field due to one or more straight wire conductors using the superposition principle',
      'Calculate the force per unit length on a current carrying wire due to the magnetic field produced by other current-carrying wires',
      'Solve problems involving magnetic fields, forces due to magnetic fields and the motion of charges and current-carrying wires in contexts such as, but not limited to, determining the strength of Earth’s magnetic field, mass spectrometers, and solenoids.',
      'Identify the factors that affect the magnitude of the induced emf and the magnitude and direction of the induced current (Faraday’s Law)',
      'Calculate the induced emf in a closed loop due to a time-varying magnetic flux using Faraday’s Law',
      'Characterize the properties (stored energy and time-dependence of charges, currents, and voltages) of an LC circuit',
      'Explain the conditions for total internal reflection',
      'Calculate the intensity of the transmitted light after passing through a series of polarizers applying Malus’s Law',
      'Solve problems involving reflection, refraction, dispersion, and polarization in contexts such as, but not limited to, (polarizing) sunglasses, atmospheric haloes, and rainbows',
      'Solve problems involving reflection, refraction, dispersion, and polarization in contexts such as, but not limited to, (polarizing) sunglasses, atmospheric haloes, and rainbows',
      'Explain image formation as an application of reflection, refraction, and paraxial approximation',
      'Determine the conditions (superposition, path and phase difference, polarization, amplitude) for interference to occur emphasizing the properties of a laser as a monochromatic and coherent light source',
      'Relate the geometry of the two-slit experiment set up (slit separation, and screen-to-slit distance) and properties of light (wavelength) to the properties of the interference pattern (width, location, and intensity)',
      'Relate the geometry of the diffraction experiment setup (slit size, and screen- to-slit distance) and properties of light (wavelength) to the properties of the diffraction pattern (width, location, and intensity of the fringes)',
      'State the postulates of Special Relativity and their consequences',
      'Apply the time dilation, length contraction and relativistic velocity addition to worded problems',
      'Calculate kinetic energy, rest energy, momentum, and speed of objects moving with speeds comparable to the speed of light',
      'Calculating radioisotope activity using the concept of half-life',
   ]),
};

export const OCG11_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'nature_and_elements_of_communication',
         label: 'Nature and Elements of Communication',
         start: 1,
         count: 12,
         mean: 9.76,
         stdDev: 1.82,
         ranges: [
            [0, 8.75, 'Beginner'],
            [8.76, 10.76, 'Basic'],
            [10.77, 12, 'Competent'],
         ],
      },
      {
         key: 'functions_of_communication',
         label: 'Functions of Communication',
         start: 13,
         count: 14,
         mean: 7,
         stdDev: 1.82,
         ranges: [
            [0, 5.17, 'Beginner'],
            [5.18, 8.82, 'Basic'],
            [8.83, 14, 'Competent'],
         ],
      },
      {
         key: 'strategies_in_various_speech_situations',
         label: 'Strategies in Various Speech Situations',
         start: 27,
         count: 14,
         mean: 5.3,
         stdDev: 1.65,
         ranges: [
            [0, 3.64, 'Beginner'],
            [3.65, 6.95, 'Basic'],
            [6.96, 14, 'Competent'],
         ],
      },
      {
         key: 'types_of_speeches',
         label: 'Types of Speeches',
         start: 41,
         count: 10,
         mean: 3.07,
         stdDev: 1.38,
         ranges: [
            [0, 1.68, 'Beginner'],
            [1.69, 4.45, 'Basic'],
            [4.46, 10, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 21.41, 'Beginner'],
      [21.42, 28.82, 'Basic'],
      [28.83, 50, 'Competent'],
   ],
   sections: [
      { label: 'A. Nature and Elements of Communication', start: 1, end: 12 },
      { label: 'B. Functions of Communication', start: 13, end: 26 },
      {
         label: 'C. Strategies in Various Speech Situations',
         start: 27,
         end: 40,
      },
      { label: 'D. Types of Speeches', start: 41, end: 50 },
   ],
   competencies: toCompetencies([
      'Defines communication.',
      'Explains the nature and process of communication.',
      'Explains the nature and process of communication.',
      'Explains the nature and process of communication.',
      'Explains why there is a breakdown of communication.',
      'Explains why there is a breakdown of communication.',
      'Uses various strategies in order to avoid communication breakdown.',
      'Uses various strategies in order to avoid communication breakdown.',
      'Uses various strategies in order to avoid communication breakdown.',
      'Uses various strategies in order to avoid communication breakdown.',
      'Uses various strategies in order to avoid communication breakdown.',
      'Demonstrates sensitivity to the socio-cultural dimension of communication.',
      'Discusses the functions of communication.',
      'Discusses the functions of communication.',
      'Identifies the speaker’s purpose(s).',
      'Identifies the speaker’s purpose(s).',
      'Identifies the speaker’s purpose(s).',
      'Ascertains the verbal and nonverbal cues that each speaker uses to achieve his/her purpose.',
      'Ascertains the verbal and nonverbal cues that each speaker uses to achieve his/her purpose.',
      'Comprehends various kinds of oral texts.',
      'Comprehends various kinds of oral texts.',
      'Comprehends various kinds of oral texts.',
      'Identifies strategies used by each speaker to convey his/her ideas effectively.',
      'Identifies strategies used by each speaker to convey his/her ideas effectively.',
      'Evaluates the effectiveness of an oral communication activity.',
      'Evaluates the effectiveness of an oral communication activity.',
      'Identifies the various types of speech context.',
      'Identifies the various types of speech context.',
      'Exhibits appropriate verbal and non-verbal behavior in a given speech context.',
      'Exhibits appropriate verbal and non-verbal behavior in a given speech context.',
      'Distinguishes types of speech style.',
      'Distinguishes types of speech style.',
      'Identifies social situations in which each speech style is appropriate to use.',
      'Identifies social situations in which each speech style is appropriate to use.',
      'Observes the appropriate language forms in using a particular speech style.',
      'Responds appropriately and effectively to a speech act.',
      'Responds appropriately and effectively to a speech act.',
      'Engages in a communicative situation using acceptable, polite and meaningful communicative strategies.',
      'Explains that a shift in speech context, speech style, speech act and communicative strategy affects the following.',
      'Explains that a shift in speech context, speech style, speech act and communicative strategy affects the following.',
      'Distinguishes types of speeches.',
      'Uses principles of effective speech delivery in different situations.',
      'Uses principles of effective speech delivery in different situations.',
      'Uses principles of effective speech writing focusing on.',
      'Uses principles of effective speech writing focusing on.',
      'Uses principles of effective speech delivery focusing on.',
      'Uses principles of effective speech delivery focusing on.',
      'Uses principles of effective speech delivery focusing on.',
      'Uses principles of effective speech delivery focusing on.',
      'Uses principles of effective speech delivery focusing on.',
   ]),
};

export const OM12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'theories_of_management',
         label: 'Theories of Management',
         start: 1,
         count: 10,
         mean: 5.2,
         stdDev: 1.93,
         ranges: [
            [0, 5.19, 'Beginner'],
            [5.2, 7.13, 'Basic'],
            [7.14, 10, 'Competent'],
         ],
      },
      {
         key: 'organizational_structure',
         label: 'Organizational Structure',
         start: 11,
         count: 20,
         mean: 10.11,
         stdDev: 3.33,
         ranges: [
            [0, 10.1, 'Beginner'],
            [10.11, 13.44, 'Basic'],
            [13.45, 20, 'Competent'],
         ],
      },
      {
         key: 'functional_areas_of_management',
         label: 'Functional Areas of Management',
         start: 31,
         count: 10,
         mean: 5.7,
         stdDev: 2.03,
         ranges: [
            [0, 5.69, 'Beginner'],
            [5.7, 7.73, 'Basic'],
            [7.74, 10, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 20, 'Beginner'],
      [20.01, 26.09, 'Basic'],
      [26.1, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Theories of Management', start: 1, end: 10 },
      { label: 'B. Organizational Structure', start: 11, end: 30 },
      { label: 'C. Functional Areas of Management', start: 31, end: 40 },
   ],
   competencies: toCompetencies([
      'Explain the meaning, functions, types and theories of management',
      'Explain the functions, roles and skills of a manager',
      'Analyze various forces/elements influencing local and international business environment using PEST and SWOT Strategies',
      'Analyze the forms and economic roles of business organizations',
      'Analyze the forms and economic roles of business organizations',
      'Differentiate the phases of economic development and its impact to business environment',
      'Discuss the nature and levels of planning and types of plans',
      'Apply appropriate planning techniques and tools in business decision-making',
      'Apply appropriate planning techniques and tools in business decision-making',
      'Analyze the nature of organizations and types of organization structures',
      'Apply organization theories for effective business management',
      'Apply organization theories for effective business management',
      'Apply organization theories for effective business management',
      'Apply organization theories for effective business management',
      'Apply organization theories for effective business management',
      'Apply organization theories for effective business management',
      'Discuss the concept and nature of staffing',
      'Discuss the concept and nature of staffing',
      'Analyze the process of recruiting, selecting and training employees',
      'Analyze the process of recruiting, selecting and training employees',
      'Analyze the process of recruiting, selecting and training employees',
      'Analyze the process of recruiting, selecting and training employees',
      'Examine the functions and importance of compensation, wages and performance evaluation, appraisal, reward system, employee relations and movement',
      'Examine the functions and importance of compensation, wages and performance evaluation, appraisal, reward system, employee relations and movement',
      'Analyze motivation, leadership, and communication work in an organization',
      'Analyze motivation, leadership, and communication work in an organization',
      'Analyze motivation, leadership, and communication work in an organization',
      'Apply the concept and nature of different control methods and techniques in accounting and marketing',
      'Apply the concept and nature of different control methods and techniques in accounting and marketing',
      'Apply the concept and nature of different control methods and techniques in accounting and marketing',
      'Explain the nature and role in the firm of the following functional areas of management: (a) Human Resource Management, (b) Marketing Management, (c) Operations Management, (d) Financial Management, € Material and Procurement Management, (f) Office Management',
      'Explain the nature and role in the firm of the following functional areas of management: (a) Human Resource Management, (b) Marketing Management, (c) Operations Management, (d) Financial Management, € Material and Procurement Management, (f) Office Management',
      'Explain the nature and role in the firm of the following functional areas of management: (a) Human Resource Management, (b) Marketing Management, (c) Operations Management, (d) Financial Management, € Material and Procurement Management, (f) Office Management',
      'Explain the nature and role in the firm of the following functional areas of management: (a) Human Resource Management, (b) Marketing Management, (c) Operations Management, (d) Financial Management, € Material and Procurement Management, (f) Office Management',
      'Explain the nature and role in the firm of the following functional areas of management: (a) Human Resource Management, (b) Marketing Management, (c) Operations Management, (d) Financial Management, € Material and Procurement Management, (f) Office Management',
      'Explain the nature and role in the firm of the following functional areas of management: (a) Human Resource Management, (b) Marketing Management, (c) Operations Management, (d) Financial Management, € Material and Procurement Management, (f) Office Management',
      'Explain the nature and role in the firm of the following functional areas of management: (a) Human Resource Management, (b) Marketing Management, (c) Operations Management, (d) Financial Management, € Material and Procurement Management, (f) Office Management',
      'Explain the steps and importance of starting a family business',
      'Explain the steps and importance of starting a family business',
      'Explain the steps and importance of starting a family business',
   ]),
};

export const PC_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'conic_sections',
         label: 'Conic Sections',
         start: 1,
         count: 13,
         mean: 6.43,
         stdDev: 1.83,
         ranges: [
            [0, 5.51, 'Beginner'],
            [5.52, 7.35, 'Basic'],
            [7.36, 13, 'Competent'],
         ],
      },
      {
         key: 'binomial_theorem',
         label: 'Binomial Theorem',
         start: 14,
         count: 8,
         mean: 4.54,
         stdDev: 1.39,
         ranges: [
            [0, 3.84, 'Beginner'],
            [3.85, 5.24, 'Basic'],
            [5.25, 8, 'Competent'],
         ],
      },
      {
         key: 'circular_functions',
         label: 'Circular Functions',
         start: 22,
         count: 19,
         mean: 9.27,
         stdDev: 1.88,
         ranges: [
            [0, 8.32, 'Beginner'],
            [8.33, 10.21, 'Basic'],
            [10.22, 19, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 18.72, 'Beginner'],
      [18.73, 22.61, 'Basic'],
      [22.62, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Conic Sections', start: 1, end: 13 },
      { label: 'B. Binomial Theorem', start: 14, end: 21 },
      { label: 'C. Circular Functions', start: 22, end: 40 },
   ],
   competencies: toCompetencies([
      'Illustrate the different types of conic sections: parabola, ellipse, circle, hyperbola, and degenerate cases.',
      'Define a circle.',
      'Determine the standard form of equation of a circle.',
      'Define a parabola',
      'Determine the standard form of equation of a parabola',
      'Define an ellipse',
      'Determine the standard form of equation of an ellipse',
      'Define a hyperbola',
      'Determine the standard form of equation of a hyperbola',
      'Recognize the equation and important characteristics of the different types of conic sections',
      'Recognize the equation and important characteristics of the different types of conic sections',
      'Solves situational problems involving conic sections',
      'Solves situational problems involving conic sections',
      'Illustrate a series',
      'Illustrate a series',
      'Differentiate a series from a sequence',
      'Differentiate a series from a sequence',
      'Use the sigma notation to represent a series',
      'Use the sigma notation to represent a series',
      'Apply the use of sigma notation in finding sums',
      'Apply the use of sigma notation in finding sums',
      'Illustrate the unit circle and the relationship between the linear and angular measures of a central angle in a unit circle',
      'Convert degree measure to radian measure and vice versa',
      'Illustrate angles in standard position and coterminal angles',
      'Illustrate the different circular functions',
      'Uses reference angles to find exact values of circular functions',
      'Illustrate the domain and range of the different circular functions',
      'Graph the six circular functions (a) amplitude, (b) period, and (c) phase shift',
      'Solve situational problems involving circular functions',
      'Solve situational problems involving circular functions',
      'Determine whether an equation is an identity or a conditional equation',
      'Apply trigonometric identities to find other trigonometric values',
      'Solve situational problems involving trigonometric identities',
      'Solve situational problems involving trigonometric identities',
      'Illustrate the domain and range of the inverse trigonometric functions.',
      'Evaluate an inverse trigonometric expression',
      'Solve trigonometric equations.',
      'Solve trigonometric equations.',
      'Solve situational problems involving inverse trigonometric functions and trigonometric equations',
      'Solve situational problems involving inverse trigonometric functions and trigonometric equations',
   ]),
};

export const PM_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'marketing_principles',
         label: 'Marketing Principles',
         start: 1,
         count: 10,
         mean: 5.38,
         stdDev: 1.66,
         ranges: [
            [0, 4.54, 'Beginner'],
            [4.55, 6.21, 'Basic'],
            [6.22, 10, 'Competent'],
         ],
      },
      {
         key: 'information_affecting_the_market',
         label: 'Information Affecting the Market',
         start: 11,
         count: 25,
         mean: 13.5,
         stdDev: 4.07,
         ranges: [
            [0, 11.46, 'Beginner'],
            [11.47, 15.54, 'Basic'],
            [15.55, 25, 'Competent'],
         ],
      },
      {
         key: 'product_development_and_marketing_plan',
         label: 'Product Development and Marketing Plan',
         start: 36,
         count: 5,
         mean: 3.21,
         stdDev: 1.17,
         ranges: [
            [0, 2.62, 'Beginner'],
            [2.63, 3.8, 'Basic'],
            [3.81, 5, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 18.39, 'Beginner'],
      [18.4, 23.81, 'Basic'],
      [23.82, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Marketing Principles', start: 1, end: 10 },
      { label: 'B. Information Affecting the Market', start: 11, end: 35 },
      {
         label: 'C. Product Development and Marketing Plan',
         start: 36,
         end: 40,
      },
   ],
   competencies: toCompetencies([
      'Define and understand marketing (Principles, Goals, Approaches)',
      'Define and understand marketing (Principles, Goals, Approaches)',
      'Define and understand marketing (Principles, Goals, Approaches)',
      'Define “relationship marketing”',
      'Define “relationship marketing”',
      'Define “relationship marketing”',
      'Explain the value of customers',
      'Explain the value of customers',
      'Explain the value of customers',
      'Explain the value of customers',
      'Distinguish between strategic and marketing planning in terms of objectives and processes',
      'Distinguish between strategic and marketing planning in terms of objectives and processes',
      'Distinguish between strategic and marketing planning in terms of objectives and processes',
      'Distinguish between strategic and marketing planning in terms of objectives and processes',
      'Analyze the elements of macro- and micro-environment and their influence to marketing planning',
      'Analyze the elements of macro- and micro-environment and their influence to marketing planning',
      'Analyze the elements of macro- and micro-environment and their influence to marketing planning',
      'Analyze the elements of macro- and micro-environment and their influence to marketing planning',
      'Define marketing research, its importance to a business enterprise and identify the steps in marketing research',
      'Define marketing research, its importance to a business enterprise and identify the steps in marketing research',
      'Define marketing research, its importance to a business enterprise and identify the steps in marketing research',
      'Define marketing research, its importance to a business enterprise and identify the steps in marketing research',
      'Differentiate the buying behavior and decision making of individual/household customer versus the business (organizational) customer',
      'Differentiate the buying behavior and decision making of individual/household customer versus the business (organizational) customer',
      'Differentiate the buying behavior and decision making of individual/household customer versus the business (organizational) customer',
      'Differentiate the buying behavior and decision making of individual/household customer versus the business (organizational) customer',
      'Identify and segment market for a product or service',
      'Identify and segment market for a product or service',
      'Identify and segment market for a product or service',
      'Identify and segment market for a product or service',
      'Select the appropriate target market segment and its positioning',
      'Select the appropriate target market segment and its positioning',
      'Select the appropriate target market segment and its positioning',
      'Select the appropriate target market segment and its positioning',
      'Select the appropriate target market segment and its positioning',
      'Define a product and differentiates the product, services, and experiences',
      'Identify and describe the factors to consider when setting prices and new product pricing and its general pricing Approaches',
      'Define and identify relevant promotional tools, namely, advertising, sales promotion, personal selling, public relations, and direct marketing to create awareness and persuade the target market to buy the product orpatronize the service',
      'Explain the relationship between market analysis, planning, implementation, and control analyze the company’s situation, markets, and environment (the marketing audit and SWOT analysis)',
      'Integrate the marketing concepts and techniques learned by preparing a marketing plan',
   ]),
};

export const PS_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'formation_of_elements_in_the_universe',
         label: 'Formation of Elements in the Universe',
         start: 1,
         count: 10,
         mean: 5.67,
         stdDev: 1.66,
         ranges: [
            [0, 4, 'Beginner'],
            [4.01, 7.33, 'Basic'],
            [7.34, 10, 'Competent'],
         ],
      },
      {
         key: 'chemical_structure_of_matter',
         label: 'Chemical Structure of Matter',
         start: 11,
         count: 8,
         mean: 3.79,
         stdDev: 0.83,
         ranges: [
            [0, 2.95, 'Beginner'],
            [2.96, 4.62, 'Basic'],
            [4.63, 8, 'Competent'],
         ],
      },
      {
         key: 'chemical_change',
         label: 'Chemical Change',
         start: 19,
         count: 7,
         mean: 3.04,
         stdDev: 1.55,
         ranges: [
            [0, 1.48, 'Beginner'],
            [1.49, 4.59, 'Basic'],
            [4.6, 7, 'Competent'],
         ],
      },
      {
         key: 'chemistry_of_household_and_personal_care_products',
         label: 'Chemistry of Household and Personal Care Products',
         start: 26,
         count: 7,
         mean: 3.33,
         stdDev: 1.17,
         ranges: [
            [0, 2.15, 'Beginner'],
            [2.16, 4.5, 'Basic'],
            [4.51, 7, 'Competent'],
         ],
      },
      {
         key: 'evolution_of_the_theories_of_the_universe',
         label: 'Evolution of the Theories of the Universe',
         start: 33,
         count: 5,
         mean: 2,
         stdDev: 1.18,
         ranges: [
            [0, 0.81, 'Beginner'],
            [0.82, 3.18, 'Basic'],
            [3.19, 5, 'Competent'],
         ],
      },
      {
         key: 'laws_of_physics_in_the_universe',
         label: 'Laws of Physics in the Universe ',
         start: 38,
         count: 7,
         mean: 4.17,
         stdDev: 1.83,
         ranges: [
            [0, 2.87, 'Beginner'],
            [2.88, 6.54, 'Basic'],
            [6.55, 7, 'Competent'],
         ],
      },
      {
         key: 'light_waves_and_particles',
         label: 'Light Waves and Particles',
         start: 45,
         count: 11,
         mean: 6.42,
         stdDev: 2.02,
         ranges: [
            [0, 4.39, 'Beginner'],
            [4.4, 8.44, 'Basic'],
            [8.45, 11, 'Competent'],
         ],
      },
      {
         key: 'relativity',
         label: 'Relativity',
         start: 56,
         count: 5,
         mean: 2,
         stdDev: 1.18,
         ranges: [
            [0, 0.81, 'Beginner'],
            [0.82, 3.18, 'Basic'],
            [3.19, 5, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 27.57, 'Beginner'],
      [27.58, 38.02, 'Basic'],
      [38.03, 60, 'Competent'],
   ],
   sections: [
      { label: 'A. Counseling', start: 1, end: 12 },
      { label: 'B. Social Work', start: 13, end: 21 },
      { label: 'C. Communication', start: 22, end: 32 },
      { label: 'D. Applied Social Sciences', start: 33, end: 35 },
   ],
   competencies: toCompetencies([
      'Identify the goals and scope of counseling',
      'Explain the principles of counseling',
      'Explain the principles of counseling',
      'Discuss roles and functions of counselors',
      'Identify specific work areas in which counselors work',
      'Identify specific work areas in which counselors work',
      'Value rights, responsibilities, and accountabilities of counselors',
      'Distinguish between ethical and unethical behaviors among counselors',
      'Describe the clientele of counseling',
      'Illustrate the different processes and methods involved in counseling',
      'Illustrate the different processes and methods involved in counseling',
      'Distinguish the needs of individuals, groups, organizations, and communities',
      'Identify the goals and scope of social work',
      'Explain the principles and core values of social work',
      'Explain the roles and functions of social workers',
      'Identify specific work areas in which social workers work',
      'Value rights, responsibilities, and accountabilities',
      'Distinguish between ethical and unethical behaviors among practitioners',
      'Describe the clientele of social work',
      'Distinguish the needs of individuals, groups, organizations and communities',
      'Illustrate the different processes and methods involved in undertaking social work',
      'Identify the goals and scope of communication',
      'Explain the principles of communication',
      'Describe the elements and levels of the communication processes',
      'Explain the roles and functions of communicators and journalists',
      'Identify specific work areas in which communicators and journalists work',
      'Explain the rights, responsibilities, and accountabilities',
      'Distinguish between ethical and unethical behaviors among practitioners',
      'Describe the clientele and audience of communication',
      'Distinguish the needs of individuals, groups, organizations, and communities',
      'Illustrate the different processes and methods involved in undertaking communication',
      'Distinguish the appropriate communication media channel(s) to use in different settings and situations',
      'Explain each of the functions of applied social science',
      'Identify situations that would require or necessitate the performance of the various functions in local /Philippine settings',
      'Evaluate the effects of certain program or projects on knowledge, attitude, and behavior of individuals, groups, and society',
   ]),
};

export const RAW_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'reading_and_thinking_strategies_across_text_type',
         label: 'Reading and Thinking strategies Across Text Type',
         start: 1,
         count: 17,
         mean: 11.83,
         stdDev: 2.44,
         ranges: [
            [0, 5.25, 'Beginner'],
            [5.26, 7.56, 'Basic'],
            [7.57, 17, 'Competent'],
         ],
      },
      {
         key: 'critical_reading_text_and_content_connections',
         label: 'Critical Reading: Text and Content Connections',
         start: 18,
         count: 28,
         mean: 16.04,
         stdDev: 1.64,
         ranges: [
            [0, 4.33, 'Beginner'],
            [4.34, 6.08, 'Basic'],
            [6.09, 28, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 15.68, 'Beginner'],
      [15.69, 20.7, 'Basic'],
      [20.71, 45, 'Competent'],
   ],
   sections: [
      {
         label: 'A. Reading and Thinking strategies Across Text Type',
         start: 1,
         end: 17,
      },
      {
         label: 'B. Critical Reading: Text and Content Connections',
         start: 18,
         end: 45,
      },
   ],
   competencies: toCompetencies([
      'Describes a written text as connected discourse.',
      'Distinguishes between and among techniques in selecting and organizing information.',
      'Distinguishes between and among techniques in selecting and organizing information.',
      'Distinguishes between and among techniques in selecting and organizing information.',
      'Distinguishes between and among techniques in selecting and organizing information.',
      'Distinguishes between and among patterns of development in writing across disciplines.',
      'Distinguishes between and among patterns of development in writing across disciplines.',
      'Distinguishes between and among patterns of development in writing across disciplines.',
      'Distinguishes between and among patterns of development in writing across disciplines.',
      'Distinguishes between and among patterns of development in writing across disciplines.',
      'Distinguishes between and among patterns of development in writing across disciplines.',
      'Distinguishes between and among patterns of development in writing across disciplines.',
      'Distinguishes between and among patterns of development in writing across disciplines.',
      'Identifies properties of a well-written text.',
      'Identifies properties of a well-written text.',
      'Identifies properties of a well-written text.',
      'Identifies properties of a well-written text.',
      'Explains critical reading as looking for ways of thinking.',
      'Identifies claims explicitly or implicitly made in a written text.',
      'Identifies claims explicitly or implicitly made in a written text.',
      'Identifies claims explicitly or implicitly made in a written text.',
      'Identifies the context in which a text was developed.',
      'Identifies the context in which a text was developed.',
      'Explains critical reading as reasoning.',
      'Formulates assertions about the content and properties of a text read',
      'Formulates assertions about the content and properties of a text read',
      'Formulates meaningful counterclaims in response to claims made in a text read',
      'Formulates meaningful counterclaims in response to claims made in a text read',
      'Determines textual evidence to validate assertions and counterclaims made about a text read.',
      'Determines textual evidence to validate assertions and counterclaims made about a text read.',
      'Explains how one’s purpose is a crucial consideration in academic and professional writing.',
      'Explains how one’s purpose is a crucial consideration in academic and professional writing.',
      'Explains how one’s purpose is a crucial consideration in academic and professional writing.',
      'Explains how one’s purpose is a crucial consideration in academic and professional writing.',
      'Identifies the unique features of and requirements in composing texts that are useful across disciplines.',
      'Identifies the unique features of and requirements in composing texts that are useful across disciplines.',
      'Identifies the unique features of and requirements in composing texts that are useful across disciplines.',
      'Identifies the unique features of and requirements in composing texts that are useful across disciplines.',
      'Identifies the unique features of and requirements in composing texts that are useful across disciplines.',
      'Identifies the unique features of and requirements in composing texts that are useful across disciplines.',
      'Identifies the unique features of and requirements in composing professional correspondence.',
      'Identifies the unique features of and requirements in composing professional correspondence.',
      'Identifies the unique features of and requirements in composing professional correspondence.',
      'Identifies the unique features of and requirements in composing professional correspondence.',
      'Identifies the unique features of and requirements in composing professional correspondence.',
   ]),
};

export const SP_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'random_variables_and_probability_distribution',
         label: 'Random Variables and Probability Distribution',
         start: 1,
         count: 9,
         mean: 5.67,
         stdDev: 1.66,
         ranges: [
            [0, 3.55, 'Beginner'],
            [3.56, 6.7, 'Basic'],
            [6.71, 9, 'Competent'],
         ],
      },
      {
         key: 'normal_distribution',
         label: 'Normal Distribution',
         start: 10,
         count: 5,
         mean: 3.79,
         stdDev: 0.83,
         ranges: [
            [0, 0.89, 'Beginner'],
            [0.9, 2.6, 'Basic'],
            [2.61, 5, 'Competent'],
         ],
      },
      {
         key: 'sampling_and_sampling_distribution',
         label: 'Sampling and Sampling Distribution',
         start: 15,
         count: 8,
         mean: 3.04,
         stdDev: 1.55,
         ranges: [
            [0, 1.92, 'Beginner'],
            [1.93, 4.41, 'Basic'],
            [4.42, 8, 'Competent'],
         ],
      },
      {
         key: 'estimation_of_parameters',
         label: 'Estimation of Parameters',
         start: 23,
         count: 17,
         mean: 3.33,
         stdDev: 1.17,
         ranges: [
            [0, 4.33, 'Beginner'],
            [4.34, 9, 'Basic'],
            [9.01, 17, 'Competent'],
         ],
      },
      {
         key: 'tests_of_hypothesis',
         label: 'Tests of Hypothesis',
         start: 40,
         count: 21,
         mean: 2,
         stdDev: 1.18,
         ranges: [
            [0, 11.32, 'Beginner'],
            [11.33, 16.17, 'Basic'],
            [16.18, 21, 'Competent'],
         ],
      },
      // { key: 'random_variables_and_probability_distribution', label: 'Random Variables and Probability Distribution', start: 1, count: 9, mean: 5.13, stdDev: 1.57, ranges: [[0, 3.55, 'Beginner'], [3.56, 6.7, 'Basic'], [6.71, 9, 'Competent']] },
      // { key: 'normaldistribution', label: 'normaldistribution', start: 11, count: 5, mean: 1.75, stdDev: 0.85, ranges: [[0, 0.89, 'Beginner'], [0.9, 2.6, 'Basic'], [2.61, 5, 'Competent']] },
      // { key: 'sampling', label: 'sampling', start: 19, count: 8, mean: 3.17, stdDev: 1.24, ranges: [[0, 1.92, 'Beginner'], [1.93, 4.41, 'Basic'], [4.42, 8, 'Competent']] },
      // { key: 'estimation', label: 'estimation', start: 26, count: 17, mean: 6.71, stdDev: 2.33, ranges: [[0, 4.33, 'Beginner'], [4.34, 9, 'Basic'], [9.01, 17, 'Competent']] },
      // { key: 'hypothesis', label: 'hypothesis', start: 33, count: 21, mean: 13.75, stdDev: 1.42, ranges: [[0, 11.32, 'Beginner'], [11.33, 16.17, 'Basic'], [16.18, 21, 'Competent']] }
   ],
   totalRanges: [
      [0, 26.46, 'Beginner'],
      [26.47, 34.53, 'Basic'],
      [34.54, 60, 'Competent'],
   ],
   sections: [
      {
         label: 'A. Random Variables and Probability Distribution',
         start: 1,
         end: 9,
      },
      { label: 'B. Normal Distribution', start: 10, end: 14 },
      { label: 'C. Sampling and Sampling Distribution', start: 15, end: 22 },
      { label: 'D. Estimation of Parameters', start: 23, end: 39 },
      { label: 'E. Tests of Hypothesis', start: 40, end: 60 },
   ],
   competencies: toCompetencies([
      'Distinguishes between a discrete and a continuous random variable.',
      'Finds the possible values of a random variable.',
      'Illustrates a probability distribution for a discrete random variable and its properties.',
      'Constructs the probability mass function of a discrete random variable and its corresponding histogram.',
      'Computes probabilities corresponding to a given random variable.',
      'Illustrates the mean and variance of a discrete random variable.',
      'Calculates the mean and the variance of a discrete random variable.',
      'Interprets the mean and the variance of a discrete random variable.',
      'Solves problems involving mean and variance of probability distributions.',
      'Illustrates a normal random variable and its characteristics.',
      'Constructs a normal curve.',
      'Identifies regions under the normal curve corresponding to different standard normal values.',
      'Converts a normal random variable to a standard normal variable and vice versa.',
      'Computes probabilities and percentiles using the standard normal table.',
      'Illustrates random sampling.',
      'Distinguishes between parameter and statistic.',
      'Identifies sampling distributions of statistics (sample mean).',
      'Finds the mean and variance of the sampling distribution of the sample mean.',
      'Defines the sampling distribution of the sample mean for normal population when the variance is: (a) known (b) unknown.',
      'Illustrates the Central Limit Theorem.',
      'Defines the sampling distribution of the sample mean using the Central Limit Theorem.',
      'Solves problems involving sampling distributions of the sample mean.',
      'Illustrates point and interval estimations.',
      'Identifies point estimator for the population mean.',
      'Computes for the point estimate of the population mean.',
      'Identifies the appropriate form of the confidence interval estimator for the population mean when: (a) the population variance is known, (b) the population variance is unknown, and (c) the Central Limit Theorem is to be used.',
      'Identifies regions under the t-distribution corresponding to different t-values.',
      'Identifies percentiles using the t-table.',
      'Computes for the confidence interval estimate based on the appropriate form of the estimator for the population mean.',
      'Solves problems involving confidence interval estimation of the population mean.',
      'Draws conclusion about the population mean based on its confidence interval estimate.',
      'Identifies point estimator for the population proportion.',
      'Computes for the point estimate of the population proportion.',
      'Computes for the confidence interval estimate of the population proportion.',
      'Solves problems involving confidence interval estimation of the population proportion.',
      'Draws conclusion about the population proportion based on its confidence interval estimate.',
      'Computes for the length of the confidence interval.',
      'Computes for an appropriate sample size using the length of the interval.',
      'Solves problems involving sample size determination.',
      'Illustrates: (a) null hypothesis (b) alternative hypothesis (c) level of significance (d) rejection region; and (e) types of errors in hypothesis testing.',
      'Illustrates: (a) null hypothesis (b) alternative hypothesis (c) level of significance (d) rejection region; and (e) types of errors in hypothesis testing.',
      'Calculates the probabilities of committing a Type I and Type II error.',
      'Identifies the parameter to be tested given a real-life problem.',
      'Formulates the appropriate null and alternative hypotheses on a population mean.',
      'Identifies the appropriate form of the test-statistic when: (a) the population variance is assumed to be known (b) the population variance is assumed to be unknown; and (c) the central Limit Theorem is to be used.',
      'Identifies the appropriate rejection region for a given level of significance when: (a) the population variance is assumed to be known (b) the population variance is assumed to be unknown; and (c) the central Limit Theorem is to be used.',
      'Computes for the test-statistic value (population mean).',
      'Draws conclusion about the population mean based on the test-statistic value and the rejection region.',
      'Solves problems involving test of hypothesis on the population mean.',
      'Formulates the appropriate null and alternative hypotheses on a population proportion.',
      'Identifies the appropriate rejection region for a given level of significance when the Central Limit Theorem is to be used.',
      'Computes for the test-statistic value (population proportion).',
      'Draws conclusion about the population proportion based on the test-statistic value and the rejection region.',
      'Solves problems involving test of hypothesis on the population proportion.',
      'Identifies the independent and dependent variables.',
      'Draws the best-fit line on a scatter plot.',
      'Calculates the slope and y-intercept of the regression line.',
      'Interprets the calculated slope and y-intercept of the regression line.',
      'Predicts the value of the dependent variable given the value of the independent variable.',
      'Solves problems involving regression analysis.',
   ]),
};

// export const GMG11_SUBJECT_CONFIG = {
//    apiVersion: 3,
//    summaryAreas: [
//       { key: 'functions_and_their_graphs', label: 'Functions and their Graphs', start: 1, count: 36, mean: 22, stdDev: 2.44, ranges: [[0, 19.52, 'Beginner'], [19.53, 24.47, 'Basic'], [24.48, 36, 'Competent']] },
//       { key: 'basic_business_mathematics', label: 'Basic Business Mathematics', start: 37, count: 7, mean: 5.38, stdDev: 1.44, ranges: [[0, 3.93, 'Beginner'], [3.94, 6.82, 'Basic'], [6.83, 7, 'Competent']] },
//       { key: 'logic', label: 'Logic', start: 44, count: 7, mean: 10.29, stdDev: 2.12, ranges: [[0, 4.19, 'Beginner'], [4.2, 6.96, 'Basic'], [6.97, 7, 'Competent']] }
//    ],
//    totalRanges: [[0, 29.27, 'Beginner'], [29.28, 34.72, 'Basic'], [34.73, 50, 'Competent']],
//    sections: [
//       { label: 'A. Functions and their Graphs', start: 1, end: 36 },
//       { label: 'B. Basic Business Mathematics', start: 37, end: 43 },
//       { label: 'C. Logic', start: 44, end: 50 }
//    ],
//    competencies: toCompetencies([
//       "Performs addition, subtraction, multiplication, division, and composition of functions.",
//       "Performs addition, subtraction, multiplication, division, and composition of functions.",
//       "Solves problems involving functions.",
//       "Solves problems involving functions.",
//       "Distinguishes rational function, rational equation, and rational inequality.",
//       "Solves rational equations and inequalities.",
//       "Solves rational equations and inequalities.",
//       "Represents a rational function through its: (a) table of values, (b) graph, and (c) equation.",
//       "Represents a rational function through its: (a) table of values, (b) graph, and (c) equation.",
//       "Finds the domain and range of a rational function.",
//       "Finds the domain and range of a rational function.",
//       "Determines the: (a) intercepts (b) zeroes; and (c) asymptotes of rational functions.",
//       "Solves problems involving rational functions, equations, and inequalities.",
//       "Determines the inverse of a one-to-one function.",
//       "Determines the inverse of a one-to-one function.",
//       "Represents an inverse function through its: (a) table of values, and (b) graph.",
//       "Finds the domain and range of an inverse function.",
//       "Finds the domain and range of an inverse function.",
//       "Solves problems involving inverse functions.",
//       "Distinguishes between exponential function, exponential equation, and exponential inequality.",
//       "Solves exponential equations and inequalities.",
//       "Solves exponential equations and inequalities.",
//       "Represents an exponential function through its: (a) table of values, (b) graph, and (c) equation.",
//       "Finds the domain and range of an exponential function.",
//       "Finds the domain and range of an exponential function.",
//       "Determines the intercepts, zeroes, and asymptotes of an exponential function.",
//       "Solves problems involving exponential functions, equations, and inequalities.",
//       "Solves problems involving exponential functions, equations, and inequalities.",
//       "Distinguishes logarithmic function, logarithmic equation, and logarithmic inequality.",
//       "Illustrates the laws of logarithms.",
//       "Solves logarithmic equations and inequalities.",
//       "Represents a logarithmic function through its: (a) table of values, (b) graph, and (c) equation.",
//       "Finds the domain and range of a logarithmic function.",
//       "Finds the domain and range of a logarithmic function.",
//       "Determines the intercepts, zeroes, and asymptotes of logarithmic functions.",
//       "Solves problems involving logarithmic functions, equations, and inequalities.",
//       "Distinguishes between simple and compound interests.",
//       "Finds the future value and present value of both simple annuities and general annuities.",
//       "Calculates the fair market value of a cash flow stream that includes an annuity.",
//       "Calculates the present value and period of deferral of a deferred annuity.",
//       "Describes the different markets for stocks and bonds.",
//       "Distinguishes between business and consumer loans.",
//       "Solves problems involving business and consumer loans (amortization, mortgage).",
//       "Illustrates a proposition.",
//       "Symbolizes propositions.",
//       "Distinguishes between simple and compound propositions.",
//       "Illustrates the different forms of conditional propositions.",
//       "Determines the truth values of propositions.",
//       "Determines the validity of categorical syllogisms.",
//       "Establishes the validity and falsity of real-life arguments using logical propositions, syllogisms, and fallacies."
//    ])
// };

export const PPGG12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'politics_and_political_science',
         label: 'Politics and Political Science',
         start: 1,
         count: 8,
         mean: 5.9,
         stdDev: 1.88,
         ranges: [
            [0, 4.85, 'Beginner'],
            [4.86, 6.64, 'Basic'],
            [6.65, 8, 'Competent'],
         ],
      },
      {
         key: 'philippine_democratic_politics',
         label: 'Philippine Democratic Politics',
         start: 9,
         count: 16,
         mean: 8.86,
         stdDev: 1.77,
         ranges: [
            [0, 8.85, 'Beginner'],
            [8.86, 10.63, 'Basic'],
            [10.64, 16, 'Competent'],
         ],
      },
      {
         key: 'social_movement_and_citizenship',
         label: 'Social Movement and Citizenship',
         start: 25,
         count: 16,
         mean: 6.13,
         stdDev: 2.07,
         ranges: [
            [0, 5.39, 'Beginner'],
            [5.4, 7.14, 'Basic'],
            [7.15, 10, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 21.85, 'Beginner'],
      [21.86, 26.79, 'Basic'],
      [26.8, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Politics and Political Science', start: 1, end: 8 },
      { label: 'B. Philippine Democratic Politics', start: 9, end: 24 },
      { label: 'C. Social Movement and Citizenship', start: 25, end: 40 },
   ],
   competencies: toCompetencies([
      'Explain the concept, relationship and importance of politics, governance and government',
      'Explain the concept, relationship and importance of politics, governance and government',
      'Differentiate the political ideologies',
      'Differentiate the political ideologies',
      'Differentiate the political ideologies',
      'Analyze the nature, dimensions/types, and consequences of power',
      'Analyze the nature, dimensions/types, and consequences of power',
      'Analyze the relationship among nations and states in the context of globalization',
      'Analyze the evolution of Philippine politics and governance',
      'Analyze the evolution of Philippine politics and governance',
      'Analyze the evolution of Philippine politics and governance',
      'Analyze the evolution of Philippine politics and governance',
      'Analyze the roles and powers of the executive branch of the government',
      'Analyze the roles and powers of the executive branch of the government',
      'Analyze the roles and powers of the executive branch of the government',
      'Differentiate the roles and responsibilities of the Philippine Senate and the House of Representatives',
      'Differentiate the roles and responsibilities of the Philippine Senate and the House of Representatives',
      'Differentiate the roles and responsibilities of the Philippine Senate and the House of Representatives',
      'Analyze the roles and responsibilities of the Philippine Judiciary',
      'Analyze the roles and responsibilities of the Philippine Judiciary',
      'Analyze the roles and responsibilities of the Philippine Judiciary',
      'Explain the roles and functions of Local Government Unit (LGU)',
      'Explain the roles and functions of Local Government Unit (LGU)',
      'Explain the roles and functions of Local Government Unit (LGU)',
      'Analyze the nature of elections and political parties in the Philippines',
      'Analyze the nature of elections and political parties in the Philippines',
      'Analyze the nature of elections and political parties in the Philippines',
      'Analyze the nature of elections and political parties in the Philippines',
      'Analyze the nature of elections and political parties in the Philippines',
      'Analyze the nature of elections and political parties in the Philippines',
      'Explain the concept, role, and contributions of civil society societies and social movements to Philippine democracy',
      'Explain the concept, role, and contributions of civil society societies and social movements to Philippine democracy',
      'Explain the concept, role, and contributions of civil society societies and social movements to Philippine democracy',
      'Explain the concept, role, and contributions of civil society societies and social movements to Philippine democracy',
      'Explain the importance of active citizenship',
      'Explain the importance of active citizenship',
      'Explain the importance of active citizenship',
      'Explain issues and programs related to political engagement and youth empowerment',
      'Explain issues and programs related to political engagement and youth empowerment',
      'Explain issues and programs related to political engagement and youth empowerment',
   ]),
};

export const GP1G12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'source_types_error',
         label: 'Sources and Types of Error',
         start: 1,
         count: 8,
         mean: 4.29,
         stdDev: 1.74,
         ranges: [
            [0, 4.28, 'Beginner'],
            [4.29, 6.03, 'Basic'],
            [6.04, 8, 'Competent'],
         ],
      },
      {
         key: 'motion',
         label: 'Motion',
         start: 9,
         count: 20,
         mean: 10.62,
         stdDev: 2.45,
         ranges: [
            [0, 10.61, 'Beginner'],
            [10.62, 13.07, 'Basic'],
            [13.08, 20, 'Competent'],
         ],
      },
      {
         key: 'inertia',
         label: 'Inertia',
         start: 29,
         count: 10,
         mean: 5.17,
         stdDev: 1.5,
         ranges: [
            [0, 5.16, 'Beginner'],
            [5.17, 6.67, 'Basic'],
            [6.68, 10, 'Competent'],
         ],
      },
      {
         key: 'wave_intensity',
         label: 'Wave Intensity',
         start: 39,
         count: 2,
         mean: 1.02,
         stdDev: 0.73,
         ranges: [
            [0, 1.01, 'Beginner'],
            [1.02, 1.75, 'Basic'],
            [1.76, 2, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 21.92, 'Beginner'],
      [21.93, 26.19, 'Basic'],
      [26.2, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Sources and Types of Error', start: 1, end: 8 },
      { label: 'B. Motion', start: 9, end: 28 },
      { label: 'C. Inertia', start: 29, end: 38 },
      { label: 'D. Wave Intensity', start: 39, end: 40 },
   ],
   competencies: toCompetencies([
      'Solve measurement problems involving conversion of units, expression of measurements in scientific notation.',
      'Estimate errors from multiple measurements of a physical quantity using variance.',
      'Perform addition of vectors.',
      'Convert a verbal description of a physical situation involving uniform acceleration in one dimension into a mathematical description.',
      'Interpret displacement and velocity, respectively, as areas under velocity vs. time and acceleration vs. time curves.',
      'Interpret velocity and acceleration, respectively, as slopes of position vs. time and velocity vs. time curves.',
      'Solve for unknown quantities in equations involving one-dimensional uniformly accelerated motion , including free fall motion.',
      'Solve problems involving one-dimensional motion with constant acceleration in contexts such as, but not limited to, the “tail-gating phenomenon”, pursuit, rocket launch, and freefall problems.',
      'Describe motion using the concept of relative velocities in 1D and 2D.',
      'Calculate range, time of flight, and maximum heights of projectiles.',
      'Solve problems involving two dimensional motion in contexts such as, but not limited to ledge jumping, movie stunts, basketball, safe locations during firework displays, and Ferris wheels.',
      'Define inertial frames of reference.',
      'Identify action-reaction pairs.',
      'Apply Newton’s 1st law to obtain quantitative and qualitative conclusions about the contact and noncontact forces acting on a body in equilibrium.',
      'Differentiate the properties of static friction and kinetic friction.',
      'Apply Newton’s 2nd law and kinematics to obtain quantitative and qualitative conclusions about the velocity and acceleration of one or more bodies, and the contact and noncontact forces acting on one or more bodies.',
      'Solve problems using Newton’s Laws of motion in contexts such as, but not limited to, ropes and pulleys, the design of mobile sculptures, transport of loads on conveyor belts, force needed to move stalled vehicles, determination of safe driving speeds on banked curved roads.',
      'Calculate the dot or scalar product of vectors.',
      'Determine the work done by a force acting on a system.',
      'Interpret the work done by a force in one dimension as an area under a Force vs. Position curve.',
      'Explain the properties and the effects of conservative forces.',
      'Use potential energy diagrams to infer force; stable, unstable, and neutral equilibria; and turning points.',
      'Solve problems involving work, energy, and power in contexts such as, but not limited to, bungee jumping, design of roller-coasters, number of people required to build structures such as the Great Pyramids and the rice terraces; power and energy requirements of human activities such as sleeping vs. sitting vs. standing, running vs. walking.',
      'Differentiate center of mass and geometric center.',
      'Relate the motion of center of mass of a system to the momentum and net external force acting on the system.',
      'Relate the momentum, impulse, force, and time of contact in a system.',
      'Compare and contrast elastic and inelastic collisions.',
      'Solve problems involving center of mass, impulse, and momentum in contexts such as, but not limited to, rocket motion, vehicle collisions, and ping-pong.',
      'Calculate the moment of inertia about a given axis of single-object and multiple-object system.',
      'Calculate magnitude and direction of torque using the definition of torque as a cross product .',
      'Determine whether a system is in static equilibrium or not.',
      'Determine angular momentum of different systems.',
      'Solve static equilibrium problems in contexts but not limited to see-saws, cable-hinge-strutsystem, leaning ladders, and weighing a heavy suitcase using a small bathroom scale.',
      'Apply the concept of gravitational potential energy in physics problems.',
      'Calculate quantities related to planetary or satellite motion.',
      'Recognize the necessary conditions for an object to undergo simple harmonic motion.',
      'Calculate the period and the frequency of spring mass, simple pendulum, and physical pendulum.',
      'Differentiate underdamped, overdamped, and critically damped motion.',
      'From a given sinusoidal wave function infer the speed, wavelength, frequency, period, direction, and wave number.',
      'Explain the connection between the Zeroth Law of Thermodynamics, temperature, thermal equilibrium, and temperature scales.',
   ]),
};

export const GB1G12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'cell_theory',
         label: 'Cell Theory',
         start: 1,
         count: 12,
         mean: 5.7,
         stdDev: 1.16,
         ranges: [
            [0, 5.69, 'Beginner'],
            [5.7, 6.86, 'Basic'],
            [6.87, 12, 'Competent'],
         ],
      },
      {
         key: 'transport_mechanism',
         label: 'Transport Mechanism',
         start: 13,
         count: 6,
         mean: 3.7,
         stdDev: 1.01,
         ranges: [
            [0, 3.69, 'Beginner'],
            [3.7, 4.71, 'Basic'],
            [4.72, 6, 'Competent'],
         ],
      },
      {
         key: 'biological_molecules',
         label: 'Functions of Biological Molecules',
         start: 19,
         count: 5,
         mean: 2.3,
         stdDev: 1.16,
         ranges: [
            [0, 2.29, 'Beginner'],
            [2.3, 3.46, 'Basic'],
            [3.47, 5, 'Competent'],
         ],
      },
      {
         key: 'adenosine_triphosphate',
         label: 'Adenosine Triphosphate',
         start: 24,
         count: 17,
         mean: 8.3,
         stdDev: 2.18,
         ranges: [
            [0, 8.29, 'Beginner'],
            [8.3, 10.48, 'Basic'],
            [10.49, 17, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 21.85, 'Beginner'],
      [21.86, 26.79, 'Basic'],
      [26.8, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Cell Theory', start: 1, end: 12 },
      { label: 'B. Transport Mechanism', start: 13, end: 18 },
      { label: 'C. Functions of Biological Molecules', start: 19, end: 23 },
      { label: 'D. Adenosine Triphosphate', start: 24, end: 40 },
   ],
   competencies: toCompetencies([
      'Explain the postulates of the cell theory.',
      'Explain the postulates of the cell theory.',
      'Describe the structure and function of major and subcellular organelles.',
      'Describe the structure and function of major and subcellular organelles.',
      'Classify different cell types (of plant/animal tissues) and specify the functions of each.',
      'Describe some cell modifications that lead to adaptation to carry out specialized functions (e.g.,microvilli, root hair),',
      'Describe some cell modifications that lead to adaptation to carry out specialized functions (e.g.,microvilli, root hair),',
      'Characterize the phases of the cell cycle and their control points',
      'Characterize the phases of the cell cycle and their control points',
      'Describe the stages of mitosis/meiosis given 2n=6 ',
      'Explain the significance or applications of mitosis/meiosis',
      'Identify disorders and diseases that result from the malfunction of the cell during the cell cycle',
      'Describe the structural components of the cell membrane',
      'Describe the structural components of the cell membrane',
      'Relate the structure and composition of the cell membrane to its function',
      'Explain transport mechanisms in cells (diffusion osmosis, facilitated transport, active transport)',
      'Explain transport mechanisms in cells (diffusion osmosis, facilitated transport, active transport)',
      'Differentiate exocytosis and endocytosis',
      'Describe the components of an enzyme',
      'Explain oxidation/reduction reactions',
      'Explain oxidation/reduction reactions',
      'Determine how factors such as pH, temperature, and substrate affect enzyme activity',
      'Determine how factors such as pH, temperature, and substrate affect enzyme activity',
      'Explain coupled reaction processes and describe the role of ATP in energy coupling and transfer',
      'Explain coupled reaction processes and describe the role of ATP in energy coupling and transfer',
      'Explain the importance of chlorophyll and other pigments',
      'Describe the patterns of electron flow through light reaction events',
      'Describe the patterns of electron flow through light reaction events',
      'Describe the significant events of the Calvin cycle',
      'Describe the significant events of the Calvin cycle',
      'Differentiate aerobic from anaerobic respiration',
      'Explain the major features and sequence the chemical events of cellular respiration',
      'Explain the major features and sequence the chemical events of cellular respiration',
      'Distinguish major features of glycolysis, Krebs cycle, electron transport system, and chemiosmosis',
      'Describe reactions that produce and consume ATP',
      'Describe reactions that produce and consume ATP',
      'Describe the role of oxygen in respiration and describe pathways of electron flow in the absence of oxygen',
      'Describe the role of oxygen in respiration and describe pathways of electron flow in the absence of oxygen',
      'Explain the advantages and disadvantages of fermentation and aerobic respiration',
      'Explain the advantages and disadvantages of fermentation and aerobic respiration',
   ]),
};

export const WRBSG12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'belief_system',
         label: 'Belief System',
         start: 1,
         count: 6,
         mean: 3.92,
         stdDev: 1.44,
         ranges: [
            [0, 3.19, 'Beginner'],
            [3.2, 4.64, 'Basic'],
            [4.65, 6, 'Competent'],
         ],
      },
      {
         key: 'judaism',
         label: 'Judaism',
         start: 7,
         count: 4,
         mean: 3.8,
         stdDev: 1.41,
         ranges: [
            [0, 3.09, 'Beginner'],
            [3.1, 4.51, 'Basic'],
            [4.52, 6, 'Competent'],
         ],
      },
      {
         key: 'islam',
         label: 'Islam',
         start: 11,
         count: 4,
         mean: 3.9,
         stdDev: 1.4,
         ranges: [
            [0, 3.19, 'Beginner'],
            [3.2, 4.6, 'Basic'],
            [4.61, 4, 'Competent'],
         ],
      },
      {
         key: 'hinduism_and_budhism',
         label: 'Hinduism and Budhism',
         start: 15,
         count: 8,
         mean: 4.5,
         stdDev: 1.5,
         ranges: [
            [0, 3.74, 'Beginner'],
            [3.75, 5.25, 'Basic'],
            [5.26, 8, 'Competent'],
         ],
      },
      {
         key: 'confucianism_taoism_and_shintoism',
         label: 'Confucianism, Taoism, and Shintoism',
         start: 23,
         count: 8,
         mean: 4.23,
         stdDev: 1.58,
         ranges: [
            [0, 3.43, 'Beginner'],
            [3.44, 5.02, 'Basic'],
            [5.03, 8, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 13.06, 'Beginner'],
      [13.07, 17.19, 'Basic'],
      [17.2, 30, 'Competent'],
   ],
   sections: [
      { label: 'A. Belief System', start: 1, end: 6 },
      { label: 'B. Judaism', start: 7, end: 10 },
      { label: 'C. Islam', start: 11, end: 14 },
      { label: 'C. Hinduism and Budhism', start: 15, end: 22 },
      { label: 'C. Confucianism, Taoism, and Shintoism', start: 23, end: 30 },
   ],
   competencies: toCompetencies([
      'Differentiate the concept, elements and characteristics of belief system, world view, religion, and spirituality',
      'Differentiate the concept, elements and characteristics of belief system, world view, religion, and spirituality',
      'Analyze the interconnectedness of geography, culture and religions',
      'Analyze the interconnectedness of geography, culture and religions',
      'Analyze the influences of religion to culture and society',
      'Analyze the influences of religion to culture and society',
      'Examine the brief history, core teachings, fundamental beliefs, practices, and related issues of Judaism',
      'Examine the brief history, core teachings, fundamental beliefs, practices, and related issues of Judaism',
      'Examine the brief history, core teachings, fundamental beliefs, practices, and related issues of Christianity.',
      'Examine the brief history, core teachings, fundamental beliefs, practices, and related issues of Christianity.',
      'Examine the brief history, core teachings, fundamental beliefs, practices, and related issues of Islam',
      'Examine the brief history, core teachings, fundamental beliefs, practices, and related issues of Islam',
      'Compare and contrast the uniqueness and similarities of Judaism, Christianity and Islam',
      'Compare and contrast the uniqueness and similarities of Judaism, Christianity and Islam',
      'Analyze the brief history, core teachings, fundamental beliefs, practices, and related issues of Hinduism',
      'Analyze the brief history, core teachings, fundamental beliefs, practices, and related issues of Hinduism',
      'Analyze the brief history, core teachings, fundamental beliefs, practices, and related issues of Theravada Buddhism',
      'Analyze the brief history, core teachings, fundamental beliefs, practices, and related issues of Theravada Buddhism',
      'Analyze the brief history, core teachings, fundamental beliefs, practices, and related issues of Mahayana Buddhism',
      'Analyze the brief history, core teachings, fundamental beliefs, practices, and related issues of Mahayana Buddhism',
      'Explain the uniqueness and similarities of Mahayana and Theravada Buddhism',
      'Explain the uniqueness and similarities of Mahayana and Theravada Buddhism',
      'Analyze the brief history, core teachings, fundamental beliefs, practices, and related issues of Confucianism',
      'Analyze the brief history, core teachings, fundamental beliefs, practices, and related issues of Confucianism',
      'Analyze the brief history, core teachings, fundamental beliefs, practices, and related issues of Taoism',
      'Analyze the brief history, core teachings, fundamental beliefs, practices, and related issues of Taoism',
      'Examine the brief history, core teachings, fundamental beliefs, practices, and related issues of Shintoism',
      'Examine the brief history, core teachings, fundamental beliefs, practices, and related issues of Shintoism',
      'Explain the uniqueness and similarities of Confucianism, Taoism and Shintoism',
      'Explain the uniqueness and similarities of Confucianism, Taoism and Shintoism',
   ]),
};

export const TNCTG12_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'emergence_of_trends_and_pattern',
         label: 'Emergence of Trends and Pattern',
         start: 1,
         count: 7,
         mean: 3.71,
         stdDev: 1.25,
         ranges: [
            [0, 3.08, 'Beginner'],
            [3.09, 4.34, 'Basic'],
            [4.35, 7, 'Competent'],
         ],
      },
      {
         key: 'strategic_analysis',
         label: 'Strategic Analysis',
         start: 8,
         count: 6,
         mean: 3.81,
         stdDev: 1.23,
         ranges: [
            [0, 3.19, 'Beginner'],
            [3.2, 4.43, 'Basic'],
            [4.44, 6, 'Competent'],
         ],
      },
      {
         key: 'components_of_networks',
         label: 'Components of Networks',
         start: 14,
         count: 6,
         mean: 3.8,
         stdDev: 1.21,
         ranges: [
            [0, 3.19, 'Beginner'],
            [3.2, 4.41, 'Basic'],
            [4.42, 6, 'Competent'],
         ],
      },
      {
         key: 'personal_and_local_action',
         label: 'Personal and Local Action',
         start: 20,
         count: 6,
         mean: 3.26,
         stdDev: 1.05,
         ranges: [
            [0, 2.73, 'Beginner'],
            [2.74, 3.79, 'Basic'],
            [3.8, 6, 'Competent'],
         ],
      },
      {
         key: 'dimensions_of_democracy',
         label: 'Dimensions of Democracy',
         start: 26,
         count: 15,
         mean: 6.14,
         stdDev: 1.39,
         ranges: [
            [0, 5.44, 'Beginner'],
            [5.45, 6.84, 'Basic'],
            [6.85, 15, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 18.87, 'Beginner'],
      [18.88, 22.05, 'Basic'],
      [22.06, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Emergence of Trends and Pattern', start: 1, end: 7 },
      { label: 'B. Strategic Analysis', start: 8, end: 13 },
      { label: 'C. Components of Networks', start: 14, end: 19 },
      { label: 'D. Personal and Local Action', start: 20, end: 25 },
      { label: 'E. Dimensions of Democracy', start: 26, end: 40 },
   ],
   competencies: toCompetencies([
      'Differentiate a trend from a fad',
      'Explain the process on how to spot a trend',
      'Point out the elements that make up a trend',
      'Describe the different characteristics of a trend',
      'Identify parts of a whole.',
      'Identify and explain an emerging pattern',
      'Identify causes and consequences',
      'Explain strategic analysis and intuitive thinking (Define strategic analysis and intuitive thinking, Differentiate key components in strategic analysis and intuitive thinking)',
      'Explain strategic analysis and intuitive thinking (Define strategic analysis and intuitive thinking, Differentiate key components in strategic analysis and intuitive thinking)',
      'Apply strategic analysis',
      'Apply strategic analysis',
      'Apply intuitive thinking in solving a problem in the community using a map of social networks',
      'Apply intuitive thinking in solving a problem in the community using a map of social networks',
      'Explain the concrete effects of globalization and to one’s daily life',
      'Explain the need for collaboration and cooperation to achieve interconnectedness of people and nations',
      'Discuss the different contributions of the parts to a whole and the important role of creative imagination in putting together the various parts of a whole',
      'Discuss the different contributions of the parts to a whole and the important role of creative imagination in putting together the various parts of a whole',
      'Illustrate the origin of the different components of a gadget, business enterprise, industrial/technological/agricultural product, etc. through a mind map and reflection essay',
      'Illustrate the origin of the different components of a gadget, business enterprise, industrial/technological/agricultural product, etc. through a mind map and reflection essay',
      'Explain the effects of consumption and production patterns on climate change',
      'Explain the effects of consumption and production patterns on climate change',
      'Explain the effects of consumption and production patterns on climate change',
      'Explain the effects of consumption and production patterns on climate change',
      'Make a stand on how the consequences of one’s action affect the lives of others and the environment',
      'Make a stand on how the consequences of one’s action affect the lives of others and the environment',
      'Identify democratic practices',
      'Explain the importance of participation in democracy',
      'Differentiate participatory from representative democracy',
      'Assess democratic interventions prevailing in political and social institutions',
      'Formulate a viable alternative to undemocratic practices',
      'Identify the dimensions of technology that are enabling and inhibiting',
      'Discuss the benefits of technology',
      'Explain the weakest link in a system using strategic and intuitive thinking',
      'Explain how information communication technology can facilitate social relationships and political movements (occupy movements)',
      'Propose a creative intervention to improve human life using ICT',
      'Differentiate connections from relationship, and networks',
      'Illustrate how the brain or neural network works',
      'Compare the neural networks with social networks',
      'Demonstrate how thinking processes are shaped by social relationships',
      'Identify the significant social roles students play within the community by creating a social map of their relationships',
   ]),
};

export const GMG11_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'numbers_and_algebra',
         label: 'Numbers and Algebra',
         start: 1,
         count: 32,
         mean: 18.09,
         stdDev: 4.66,
         ranges: [
            [0, 15.75, 'Beginner'],
            [15.76, 24.8, 'Basic'],
            [24.81, 32, 'Competent'],
         ],
      },
      {
         key: 'measurement_and_geometry',
         label: 'Measurement and Geometry',
         start: 33,
         count: 15,
         mean: 7.4,
         stdDev: 2.57,
         ranges: [
            [0, 6.1, 'Beginner'],
            [6.11, 9.8, 'Basic'],
            [9.81, 15, 'Competent'],
         ],
      },
      {
         key: 'data_and_probability',
         label: 'Data and Probability',
         start: 48,
         count: 23,
         mean: 10.39,
         stdDev: 3.19,
         ranges: [
            [0, 8.79, 'Beginner'],
            [8.8, 14.0, 'Basic'],
            [14.01, 23, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 32.66, 'Beginner'],
      [32.67, 51.1, 'Basic'],
      [51.11, 70, 'Competent'],
   ],
   sections: [
      { label: 'A. Numbers and Algebra', start: 1, end: 32 },
      { label: 'B. Measurement and Geometry', start: 33, end: 47 },
      { label: 'C. Data and Probability', start: 48, end: 70 },
   ],
   competencies: toCompetencies([
      'Calculate weekly or monthly wages from an annual salary, wages from an hourly rate, including situations involving overtime and other allowances, and earnings based on commission or piecework;',
      'Apply a percentage increase or decrease in various contexts: determining the impact of inflation on costs and wages over time, calculating percentage mark-ups and discounts, calculating VAT, calculating profit or loss in both absolute and percentage terms.',
      'Solve problems involving salaries, wages, benefits, and deductions (tax computations, overtime pay, and gross and net incomes) using appropriate methods.',
      'Describe patterns by inspection including patterns in art and nature;',
      'Determine the next term of a given pattern, including the Fibonacci sequence;',
      'Identify the rule of a given pattern;',
      'Illustrate the attributes of arithmetic and geometric sequences;',
      'Solve problems involving arithmetic and geometric sequences;',
      'Differentiate sequences from series;',
      'Illustrate arithmetic and geometric series;',
      'Represent series using sigma notation and vice versa;',
      'Find the sum of arithmetic and geometric series;',
      'Solve problems involving arithmetic and geometric series;',
      'Apply sequences and series to solve financial problems, such as periodic payments for loans and mortgages; and',
      'Determine the accumulated values of investment over time using sequences and series.',
      'Classify functions based on their graphs and/or equations to determine if they are linear, absolute value, quadratic, square root, or cube root;',
      'Sketch the graph of the following functions: linear, absolute value, quadratic, square root, or cube root with or without technology;',
      'Apply functions to model and solve real-life problems;',
      'Illustrate a piecewise function in practical contexts (i.e., fare rates, purchasing, and income tax);',
      'Solve practical problems involving piecewise functions;',
      'Solve problems involving compound interest, including maturity value, future value, nominal rates, and number of terms;',
      'Illustrate simple annuity, general annuity, and deferred annuity;',
      'Solve problems involving annuities;',
      'Calculate the fair market value of a cash flow stream that includes an annuity;',
      'Differentiate between business and consumer loans and their characteristics, such as repayment terms, requirements, purpose, and interest rates;',
      'Solve problems involving business and consumer loans (e.g., amortization, mortgage);',
      'Identify logical propositions;',
      'Differentiate simple from compound propositions;',
      'Illustrate basic logical operations;',
      'Illustrate the different forms of conditional propositions;',
      'Illustrate different types of tautologies and contradictions using practical situations;',
      'Determine the truth values of propositions in a practical situation.',
      'Determine and apply the appropriate metric units for various contexts, such as units for small and large quantities and scientific measurements;',
      'Convert measurements with different units in the same system and between different systems;',
      'Determine the surface area of three-dimensional objects, such as prisms, pyramids, cylinders, cones, spheres, and combinations of these;',
      'Calculate the volume of prisms, pyramids, cylinders, cones, spheres, and combinations of these;',
      'Use a scale to interpret and compare distances on maps, blueprints, and sketches;',
      'Solve problems involving the conversion of currencies;',
      'Apply time conversions in various real-world scenarios such as travel planning, project management, and daily routine schedules for personal and business transactions;',
      'Apply temperature conversions to real-world scenarios such as recipe adjustments, weather reports, scientific experiments, storage conditions, and energy efficiency;',
      'Illustrate the trigonometric ratios in a right-angled triangle using a real-life object or figure;',
      'Illustrate the area of oblique triangles (i.e., Heron’s Formula and the rule Area = 1/2 abSinC);',
      'Solve practical problems involving right and oblique triangles: right and oblique triangles, angles of elevation and depression, the use of bearings in navigation',
      'Estimate and measure lengths and distances (e.g., floor dimensions, measuring fabric for clothing);',
      'Calculate the area and perimeter of residential spaces (e.g., room renovations, garden layouts);',
      'Calculate the volume and capacity of three-dimensional objects (e.g., water tanks, rice storage containers, balik-bayan boxes);',
      'Apply volume and capacity in cost estimation (e.g., amount of flour needed for bread production, paint needed for walls);',
      'Identify different types of data;',
      'Classify a given set of data according to its level of measurement;',
      'Identify the appropriate measure of central tendency and measures of variability of a given data set for different purposes;',
      'Use appropriate technologies (e.g., calculator, Excel, Jamovi, Geogebra, etc.) to calculate measures of central tendency and variability; and',
      'Interpret computed measures of central tendency and variability.',
      'Differentiate between discrete and continuous random variables and describe their uses;',
      'Calculate the expected value, variance, and standard deviation of discrete random variables;',
      'Illustrate a normal random variable and its characteristics;',
      'Convert a normal random variable to a standard normal variable and vice versa;',
      'Compute probabilities and percentiles involving the standard normal distribution using a z-distribution table or appropriate technologies;',
      'Solve problems involving normal distribution;',
      'Illustrate random sampling;',
      'Determine the appropriate sample size for a specific investigation;',
      'Distinguish between parameter and statistic, and probability and nonprobability sampling techniques.',
      'Illustrate the following concepts in hypothesis testing: null hypothesis, alternative hypothesis, level of significance, types of error',
      'Formulate the null and alternative hypotheses of a given problem;',
      'Determine the (a) level of significance and (b) types of error appropriate to a given hypothesis;',
      'Test hypotheses for one and two population means using technology employing the following statistical tools: z-test for known standard deviation, z-test for unknown standard deviation, one-sample t-test, independent samples t-test, paired samples t-test',
      'Construct a scatter plot and estimate the strength of association between variables;',
      'Draw the line of best fit for a scatter plot;',
      'Determine the degree of relationship between two variables using Pearson’s r correlation;',
      'Conclude from the results of hypothesis testing on one and two population means using t-test and z-test: relationship using Pearson r correlations',
      'Conclude from the results of hypothesis testing on one and two population: means using t-test and z-test: one and two population means using t-test and z-test ',
   ]),
};

export const GSG11_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'physics',
         label: 'Physics',
         start: 1,
         count: 12,
         mean: 9.68,
         stdDev: 1.99,
         ranges: [
            [0, 7.68, 'Beginner'],
            [7.69, 10.68, 'Basic'],
            [10.69, 12, 'Competent'],
         ],
      },
      {
         key: 'chemistry',
         label: 'Chemistry',
         start: 13,
         count: 11,
         mean: 8.8,
         stdDev: 1.87,
         ranges: [
            [0, 6.8, 'Beginner'],
            [6.81, 9.8, 'Basic'],
            [9.81, 11, 'Competent'],
         ],
      },
      {
         key: 'biology',
         label: 'Biology',
         start: 24,
         count: 12,
         mean: 9.51,
         stdDev: 2.14,
         ranges: [
            [0, 7.36, 'Beginner'],
            [7.37, 10.58, 'Basic'],
            [10.59, 12, 'Competent'],
         ],
      },
      {
         key: 'earth_and_space',
         label: 'Earth and Space',
         start: 36,
         count: 10,
         mean: 7.78,
         stdDev: 2.06,
         ranges: [
            [0, 5.71, 'Beginner'],
            [5.72, 8.81, 'Basic'],
            [8.82, 10, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 27.54, 'Beginner'],
      [27.55, 37.38, 'Basic'],
      [37.39, 45, 'Competent'],
   ],
   sections: [
      { label: 'A. Physics', start: 1, end: 12 },
      { label: 'B. Chemistry', start: 13, end: 23 },
      { label: 'C. Biology', start: 24, end: 36 },
      { label: 'D. Earth and Space', start: 37, end: 45 },
   ],
   competencies: toCompetencies([
      'Identify various ways physics enhances our quality of life across different areas, including household activities, health and safety, work productivity, and leisure.',
      'Compare and contrast translational and rotational motion in terms of their respective linear and angular quantities;',
      'Demonstrate through simple activities the relationship between linear and angular quantities;',
      'Apply concepts of translational and rotational motion in human movement (e.g., exercises, dance, and gymnastics).',
      'Apply concepts of translational and rotational motion in ergonomic designs (e.g., buildings, vehicles, furniture, and toys).',
      'Apply concepts of translational and rotational motion to design and build prototypes of efficient simple and compound machines;',
      'Explain the characteristics of efficient simple and compound machines;',
      'Explain how simple hydraulic systems use fluid principles to enhance simple and compound machines;',
      'Identify applications of Archimedes’ principle and Pascal’s principle in various contexts, such as home, community, businesses, and transportation;',
      'Design simple practical activities or models to determine how variations in physical properties, such as shape, mass, and volume, affect an object' /'s ability to float in a fluid;',
      'Discuss safety practices in dealing with electrical hazards, such as overloading, damaged insulation, damp electrical conditions, faulty wiring, and electrocution;',
      'Propose ways to minimize energy loss and energy wastage in homes, schools, local businesses, and other parts of society;',
      'Discuss properties of light and sound waves related to communications technology, navigation, medicine, and entertainment; and',
      'Identify innovations related to sound and light, such as soundproofing, sound amplifiers, LEDs, holograms, and lasers.',
      'Use information from secondary resources to report how Louis Pasteur combined research from the fields of chemistry and biology, which has helped scientists understand the cause of some diseases and prevent infection;',
      'Construct a table using product labels that describe the function of the different substances (elements or compounds) present in household products such as those in bleach, detergents, baking powder, and personal care products such as shampoo, soaps, and toothpaste;',
      'Explain the benefits and potential risks of using and disposing of household and personal care products, by considering their chemical composition, environmental impact, and human health effects, referring to the Department of Trade and Industry (DTI), Food and Drug Administration (FDA), and the Department of Environment and Natural Resources (DENR);',
      'Explain some of the common types of chemical reactions and provide examples for the following: decomposition, acid on carbonates, acids on metals, and combustion;',
      'Identify the type of chemical reactions that occur in our daily activities, including baking, cleaning, and burning;',
      'Use chemical equations to show biological and environmental processes such as photosynthesis and respiration;',
      'Describe the chemical reactions that take place in our body cells, which are referred to as metabolism, and explain their significance;',
      'Explain the characteristics of solutions and their examples in household products, industry, and environmental science;',
      'Apply best practices in the proper handling, storage, and disposal of chemicals;',
      'Investigate how much salt dissolved in water will prevent the growth of a simple garden plant; and',
      'Create a table to show how solutions of saltwater and wastewater can affect local ecosystems and recommend ways to minimize their negative impact on the environment.',
      'Explain using photographs or videos of simple plants or animals as examples how life forms operate as systems of related parts working together;',
      'Create a diagram to show the relationship between the structural components of a biological system and their functions;',
      'Describe how cells obtain nutrients from food and convert them into energy through cellular processes to sustain life in plants and animals;',
      'Explain how various plant organs interact to facilitate the transport of materials throughout the plant system;',
      'Describe how a damaged part in a system affects the organism using the case of a torn ACL (skeletal and muscular) and an asthma attack (respiratory and circulatory);',
      'Explain how the nervous and endocrine systems work together to regulate body temperature in response to stimuli;',
      'Explain how vaccines work by relating to the functions of the immune system and lymphatic system in protecting an organism against infectious diseases;',
      'Describe what is meant by the term climate change;',
      'Describe how biological systems respond to climate change and contribute to understanding its effects on living organisms in the Philippines;',
      'Explain how climate change impacts Philippine ecosystems;',
      'Propose ways to adapt and mitigate the impacts of climate change on local biodiversity; and',
      'Analyze information from secondary sources to evaluate the adverse effects of overpopulation locally and globally.',
      'Explain the characteristics of Earth that support life in comparison with the other planets of the solar system;',
      'Describe how the greenhouse effect regulates Earth' /'s temperature, making it suitable for life;',
      'Demonstrate how the Philippine archipelago was formed;',
      'Explain using suitable resources, including images, maps, and cross-sections, the unique landforms, climate, and life forms of the Philippine archipelago that have developed due to its geographical and geological location on Earth;',
      'Describe the distinctive properties and local availability of Earth materials, including rocks, minerals, and soils, and how they are harnessed to support human activities and industries;',
      'Describe geological and hydrometeorological hazards, such as volcanic eruptions, earthquakes, tsunamis, typhoons, floods, and landslides, and slowly acting processes, such as soil erosion and saltwater intrusion;',
      'Use evidence from secondary resources to describe how human activities have contributed to the modification of landforms and bodies of water of the Philippines since the beginning of the Neolithic period (~6,000 BCE);',
      'Assess geological and hydrometeorological hazards (e.g., tropical cyclones, ipo-ipo, thunderstorms, coastal storm surges, and heat waves) in terms of risks and prevention and mitigation strategies;',
      'Describe how the PAGASA iHeat (heat index) maps provide Filipinos with the knowledge they need to take proactive measures to protect themselves from heat-related illnesses; and',
      'Develop family preparedness plans and community-based disaster risk reduction and management plans to prepare for, respond to, and recover from geological and hydrometeorological hazards that affect the Philippines.',
   ]),
};

export const LCSG11_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'developmental_tasks',
         label: 'Developmental Tasks: protective and risk factors, sense of self, and health and wellness',
         start: 1,
         count: 9,
         mean: 7.29,
         stdDev: 1.48,
         ranges: [
            [0, 5.8, 'Beginner'],
            [5.81, 8.03, 'Basic'],
            [8.04, 9, 'Competent'],
         ],
      },
      {
         key: 'interpersonal_effectiveness',
         label: 'Interpersonal Effectiveness',
         start: 10,
         count: 9,
         mean: 7.65,
         stdDev: 1.08,
         ranges: [
            [0, 6.56, 'Beginner'],
            [6.57, 8.19, 'Basic'],
            [8.2, 9, 'Competent'],
         ],
      },
      {
         key: 'career_planning',
         label: 'Career Planning',
         start: 19,
         count: 12,
         mean: 9.63,
         stdDev: 2.33,
         ranges: [
            [0, 7.29, 'Beginner'],
            [7.3, 10.8, 'Basic'],
            [10.81, 12, 'Competent'],
         ],
      },
      {
         key: 'preparation_for_a_future_career',
         label: 'Preparation for a Future Career',
         start: 31,
         count: 10,
         mean: 7.76,
         stdDev: 2.35,
         ranges: [
            [0, 5.4, 'Beginner'],
            [5.41, 8.94, 'Basic'],
            [8.95, 10, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 28.29, 'Beginner'],
      [28.3, 37.33, 'Basic'],
      [37.34, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Developmental Tasks: protective and risk factors, sense of self, and health and wellness', start: 1, end: 9 },
      { label: 'B. Interpersonal Effectiveness', start: 10, end: 18 },
      { label: 'C. Career Planning', start: 19, end: 30 },
      { label: 'D. Preparation for a Future Career', start: 31, end: 40 },
   ],
   competencies: toCompetencies([
      'Examine their own sense of self through understanding key developmental stages, tasks, and protective and risk factors of late adolescence and early adulthood: Physiological development',
      'Examine their own sense of self through understanding key developmental stages, tasks, and protective and risk factors of late adolescence and early adulthood: Psychosocial development',
      'Examine their own sense of self through understanding key developmental stages, tasks, and protective and risk factors of late adolescence and early adulthood: Emotional development',
      'Exhibit understanding of routines that promote physiological development, health, personal development, and well-being: Fitness',
      'Exhibit understanding of routines that promote physiological development, health, personal development, and well-being: Mindfulness',
      'Exhibit understanding of routines that promote physiological development, health, personal development, and well-being: other physical activities',
      'Reflect on their own personal experiences that support self-awareness, self-acceptance, and self-regulation: Personal and Social',
      'Reflect on their own personal experiences that support self-awareness, self-acceptance, and self-regulation: Academic',
      'Reflect on their own personal experiences that support self-awareness, self-acceptance, and self-regulation: Digital',
      'Articulate the importance of having healthy relationships: Social Influence, Social Perception, Social Interaction',
      'Articulate the importance of having healthy relationships: Cooperation, Accommodation, Competition, Conflict',
      'Articulate the importance of having healthy relationships: Mental Health and Well-Being',
      'Apply interpersonal effectiveness principles and practices in different social situations: Interpersonal Effectiveness',
      'Apply interpersonal effectiveness principles and practices in different social situations: Empathy, Pro-Social Behavior',
      'Apply interpersonal effectiveness principles and practices in different social situations: Compassion, Fairness, and Kindness',
      'Apply skills in enhancing social interaction through different social activities: Group Activities',
      'Apply skills in enhancing social interaction through different social activities: Team sports',
      'Apply skills in enhancing social interaction through different social activities: Recreational and Rhythmic Activities',
      'Discuss the importance of considering personal, social, and environmental factors in career planning: Skills, Interests, and Talents',
      'Discuss the importance of considering personal, social, and environmental factors in career planning: Academic and Skills Requirements',
      'Discuss the importance of considering personal, social, and environmental factors in career planning: Influences (e.g., economic considerations, parent’s decision, in-demand careers, etc.)',
      'Analyze the importance of workplace considerations on career success: Basic Rights of Employees',
      'Analyze the importance of workplace considerations on career success: Responsibilities of Employers',
      'Analyze the importance of workplace considerations on career success: Occupational Wellness',
      'Examine the importance of desirable work behaviors that impact the development of career competence: Workplace Etiquette',
      'Examine the importance of desirable work behaviors that impact the development of career competence: Workplace Etiquette',
      'Examine the importance of desirable work behaviors that impact the development of career competence: Management of Workplace Resources',
      'Demonstrate ability to incorporate physical activities that promote work-life balance: Simple Physical Exercises',
      'Demonstrate ability to incorporate physical activities that promote work-life balance: Sports Activities',
      'Demonstrate ability to incorporate physical activities that promote work-life balance: Leisure Activities',
      'Evaluate requirements of different pathways for various career opportunities: Higher Education',
      'Evaluate requirements of different pathways for various career opportunities: Employment',
      'Evaluate requirements of different pathways for various career opportunities: Entrepreneurship',
      'Engage in career readiness activities: Higher Education',
      'Engage in career readiness activities: Employment application',
      'Engage in career readiness activities: Entrepreneurship',
      'Survey different sources of information for career readiness: Sources of Career Information',
      'Survey different sources of information for career readiness: Sources of Labor Market Information',
      'Survey different sources of information for career readiness: Sources of Labor Market Information',
      'Survey different sources of information for career readiness: Web-based Career Education Platforms',
   ]),
};

export const KPG11_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'heograpiya',
         label: 'Heograpiya at Kultura',
         start: 1,
         count: 10,
         mean: 7.31,
         stdDev: 2.17,
         ranges: [
            [0, 5.13, 'Beginner'],
            [5.14, 8.4, 'Basic'],
            [8.41, 10, 'Competent'],
         ],
      },
      {
         key: 'kamalayan',
         label: 'Pagusbong ng Kamalayang Pilipino',
         start: 11,
         count: 12,
         mean: 9.26,
         stdDev: 2.69,
         ranges: [
            [0, 6.56, 'Beginner'],
            [6.57, 10.61, 'Basic'],
            [10.62, 12, 'Competent'],
         ],
      },
      {
         key: 'likas_kaya',
         label: 'Likas-Kayang Pag-unlad',
         start: 23,
         count: 9,
         mean: 7.4,
         stdDev: 1.94,
         ranges: [
            [0, 5.45, 'Beginner'],
            [5.46, 8.37, 'Basic'],
            [8.38, 9, 'Competent'],
         ],
      },
      {
         key: 'pagkamamamayan',
         label: 'Pagkamamamayan',
         start: 32,
         count: 9,
         mean: 7.68,
         stdDev: 2.16,
         ranges: [
            [0, 5.51, 'Beginner'],
            [5.52, 8.76, 'Basic'],
            [8.77, 9, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 24.8, 'Beginner'],
      [24.81, 36.57, 'Basic'],
      [36.58, 40, 'Competent'],
   ],
   sections: [
      { label: 'A. Heograpiya at Kultura', start: 1, end: 10 },
      { label: 'B. Pagusbong ng Kamalayang Pilipino', start: 11, end: 22 },
      { label: 'C. Likas-Kayang Pag-unlad', start: 23, end: 31 },
      { label: 'D. Pagkamamamayan', start: 32, end: 40 },
   ],
   competencies: toCompetencies([
      'Natatalakay ang kahulugan at katuturan ng kamalayang pangkasaysayan',
      'Natatalakay ang kahulugan at katuturan ng kamalayang pangkasaysayan',
      'Nasusuri ang ugnayan ng heograpiya at kultura sa kamalayang pangkasaysayan gamit ang piling mga pamayanan at karanasan',
      'Nasusuri ang ugnayan ng heograpiya at kultura sa kamalayang pangkasaysayan gamit ang piling mga pamayanan at karanasan',
      'Naiuugnay ang mga kultura at kamalayang pangkasaysayan sa sariling konteksto at karanasan',
      'Naiuugnay ang mga kultura at kamalayang pangkasaysayan sa sariling konteksto at karanasan',
      'Nasusuri ang umiiral na paniniwala at pananampalataya ng kalinangang Pilipino',
      'Nasusuri ang umiiral na paniniwala at pananampalataya ng kalinangang Pilipino',
      'Naiuugnay ang personal at panlipunang paniniwala at pananampalataya sa kamalayang pangkasaysayan',
      'Naiuugnay ang personal at panlipunang paniniwala at pananampalataya sa kamalayang pangkasaysayan',
      'Naipaliliwanag ang kahulugan at katuturan ng pakikibaka bilang salik sa pag-usbong ng kamalayang Pilipino',
      'Naipaliliwanag ang kahulugan at katuturan ng pakikibaka bilang salik sa pag-usbong ng kamalayang Pilipino',
      'Nasusuri ang mga kolektibong karanasan ng pakikibaka laban sa mga dayuhan gamit ang piling kaso (cases) sa kasaysayan',
      'Nasusuri ang mga kolektibong karanasan ng pakikibaka laban sa mga dayuhan gamit ang piling kaso (cases) sa kasaysayan',
      'Natataya ang bunga ng mga kilusang panlipunan tulad ng kilusang agraryo, propaganda, at himagsikan sa pagsulong ng kamalayang Pilipino',
      'Natataya ang bunga ng mga kilusang panlipunan tulad ng kilusang agraryo, propaganda, at himagsikan sa pagsulong ng kamalayang Pilipino',
      'Nasusuri ang kolektibong karanasan ng pakikiangkop sa panahon ng pagsasarili gamit ang piling kaso (cases)',
      'Nasusuri ang kolektibong karanasan ng pakikiangkop sa panahon ng pagsasarili gamit ang piling kaso (cases)',
      'Natataya ang bunga ng pakikiangkop ng mga Pilipino sa pagsulong ng kamalayang Pilipino',
      'Natataya ang bunga ng pakikiangkop ng mga Pilipino sa pagsulong ng kamalayang Pilipino',
      'Naiuugnay ang personal sa pangkalahatang karanasan ng pakikibaka at pakikiangkop',
      'Naiuugnay ang personal sa pangkalahatang karanasan ng pakikibaka at pakikiangkop',
      'Natatalakay ang mga konseptong kaugnay ng likás-kayang pag-unlad',
      'Natatalakay ang mga konseptong kaugnay ng likás-kayang pag-unlad',
      'Nasusuri ang mga opisyal na dokumentong nagsusulong ng likás-kayang pag-unlad',
      'Nasusuri ang mga opisyal na dokumentong nagsusulong ng likás-kayang pag-unlad',
      'Nasusuri ang mga piling programang panlipunang nagsusulong ng likás-kayang pag-unlad',
      'Nasusuri ang mga piling programang panlipunang nagsusulong ng likás-kayang pag-unlad',
      'Nasusuri ang mga piling programang panlipunang nagsusulong ng likás-kayang pag-unlad',
      'Napahahalagahan ang likás-kayang pag-unlad bilang pundasyon ng pagsasakatuparan ng katarungang panlipunan',
      'Napahahalagahan ang likás-kayang pag-unlad bilang pundasyon ng pagsasakatuparan ng katarungang panlipunan',
      'Natatalakay ang mga kaisipang kaugnay sa pagkamamamayan',
      'Natatalakay ang mga kaisipang kaugnay sa pagkamamamayan',
      'Nasusuri ang pangkalahatang karapatan at tungkulin ng mamamayan sa pagtatamo ng pambansang kaunlaran',
      'Nasusuri ang pangkalahatang karapatan at tungkulin ng mamamayan sa pagtatamo ng pambansang kaunlaran',
      'Nakapagsasagawa ng mga hakbang ng pakikiisa tungo sa pambansang kaunlaran',
      'Nakapagsasagawa ng mga hakbang ng pakikiisa tungo sa pambansang kaunlaran',
      'Nakapagsasagawa ng mga hakbang ng pakikiisa tungo sa pambansang kaunlaran',
      'Napahahalagahan ang bahagi ng bawat mamamayan sa pagtatamo ng pambansang kaunlaran',
      'Napahahalagahan ang bahagi ng bawat mamamayan sa pagtatamo ng pambansang kaunlaran',
   ]),
};

export const ECG11_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'roles',
         label: 'Perform specific roles in controlled and uncontrolled personal and interpersonal communication events',
         start: 1,
         count: 11,
         mean: 9.56,
         stdDev: 0.91,
         ranges: [
            [0, 8.64, 'Beginner'],
            [8.65, 9.11, 'Basic'],
            [9.12, 11, 'Competent'],
         ],
      },
      {
         key: 'comm_events',
         label: 'Communicative events that involve diverse social and cultural groups',
         start: 12,
         count: 9,
         mean: 7.96,
         stdDev: 1.02,
         ranges: [
            [0, 6.67, 'Beginner'],
            [6.68, 7.32, 'Basic'],
            [7.33, 9, 'Competent'],
         ],
      },
      {
         key: 'multimodal',
         label: 'Spoken, written, and multimodal academic and technical texts for specific purposes and audiences',
         start: 21,
         count: 14,
         mean: 11.09,
         stdDev: 1.44,
         ranges: [
            [0, 9.64, 'Beginner'],
            [9.65, 10.37, 'Basic'],
            [10.38, 14, 'Competent'],
         ],
      },
      {
         key: 'correspondence',
         label: 'Types of correspondence following specific writing conventions',
         start: 35,
         count: 11,
         mean: 9.36,
         stdDev: 1.5,
         ranges: [
            [0, 7.85, 'Beginner'],
            [7.86, 8.61, 'Basic'],
            [8.62, 11, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 35.73, 'Beginner'],
      [35.74, 37.85, 'Basic'],
      [37.86, 45, 'Competent'],
   ],
   sections: [
      {
         label: 'A. Perform specific roles in controlled and uncontrolled personal and interpersonal communication events',
         start: 1,
         end: 11,
      },
      {
         label: 'B. Communicative events that involve diverse social and cultural groups',
         start: 12,
         end: 20,
      },
      {
         label: 'C. Spoken, written, and multimodal academic and technical texts for specific purposes and audiences',
         start: 21,
         end: 34,
      },
      {
         label: 'D. Types of correspondence following specific writing conventions',
         start: 35,
         end: 45,
      },
   ],
   // Sub-competency labels group the item-level competencies below them. They are
   // headings only (no item index / score) and are rendered as sub-label rows by
   // the SHS report templates. start/end are 1-based item indexes, inclusive.
   subLabels: [
      {
         label: 'A-1. Interpreting meaning in spoken, written, and multimodal personal and interpersonal texts and how it is shaped by audience, purpose, and context',
         start: 1,
         end: 3,
      },
      {
         label: 'A-2. Engaging effectively in personal and interpersonal communication using appropriate verbal and non-verbal strategies',
         start: 4,
         end: 6,
      },
      {
         label: 'A-3. Expressing ideas clearly and coherently in spoken, written, and multimodal forms for specific personal and interpersonal purposes, audiences, and contexts',
         start: 7,
         end: 9,
      },
      {
         label: 'A-4. Reflecting on the processes of interpretation, engagement, and expression in personal and interpersonal communication',
         start: 10,
         end: 11,
      },
      {
         label: 'B-1. Interpreting meaning in spoken, written, and multimodal texts and how it is shaped by cultural context, values, and social norms and dynamics',
         start: 12,
         end: 14,
      },
      {
         label: 'B-2. Engaging effectively in social communication using culturally appropriate verbal and non-verbal strategies',
         start: 15,
         end: 16,
      },
      {
         label: 'B-3. Expressing ideas using inclusive and respectful language in spoken, written, and multimodal forms for specific social and cultural purposes, audiences, and contexts',
         start: 17,
         end: 19,
      },
      {
         label: 'B-4. Reflecting on the processes of interpretation, engagement, and expression in social and cultural communication',
         start: 20,
         end: 20,
      },
      {
         label: 'C-1. Interpreting meaning in spoken, written, and multimodal academic and technical texts and how it is shaped by audience, purpose, and context',
         start: 21,
         end: 24,
      },
      {
         label: 'C-2. Engaging effectively in interactive communication in academic and training contexts',
         start: 25,
         end: 28,
      },
      {
         label: 'C-3. Expressing ideas clearly and coherently in spoken, written, and multimodal forms for academic and technical purposes, audiences, and contexts',
         start: 29,
         end: 32,
      },
      {
         label: 'C-4. Reflecting on the processes of interpretation, engagement, and expression in academic and technical communication',
         start: 33,
         end: 34,
      },
      {
         label: 'D-1. Engaging effectively in interactive communication in workplace and professional contexts',
         start: 37,
         end: 39,
      },
      {
         label: 'D-2. Expressing ideas clearly and coherently in spoken, written, and multimodal forms for specific workplace and professional purposes, audiences, and contexts',
         start: 40,
         end: 42,
      },
      {
         label: 'D-3. Reflecting on the processes of interpretation, engagement, and expression in workplace and professional communication',
         start: 43,
         end: 45,
      },
   ],
   competencies: toCompetencies([
      'Determine how language and tone are used purposefully in discussing a variety of personal and interpersonal topics.',
      'Extract main points from spoken, written, and multimodal texts (e.g., recorded and live extended personal interactions).',
      'Analyze the content and intent of personal and interpersonal communication (e.g., conversation and correspondence).',
      'Use language, tone, and structure appropriately for audience, purpose, and context in discussing a variety of personal and interpersonal topics.',
      'Use politeness markers and conversation management signals and strategies (e.g., topic nomination, topic shift/control, turn-taking, back-channeling, feedback-giving, and topic termination).',
      'Use appropriate non-verbal strategies to enhance the quality of personal and interpersonal conversation.',
      'Compose well-structured personal and interpersonal communication, showing awareness of audience and purpose (e.g., reporting observations, narrating experiences, or articulating opinions).',
      'Engage in intrapersonal communication (e.g., diary writing, journaling, building a social media profile) to reflect on learning and experiences, set goals, and establish an online presence while safeguarding privacy.',
      'Employ language and structure (e.g., use of transition/cohesive devices) appropriately and effectively for a variety of purposes.',
      'Describe processes of interpretation, engagement, and expression used for communication in personal and interpersonal contexts, demonstrating awareness of their purposes.',
      'Review one’s participation in personal and interpersonal communication, identifying strengths and areas for growth to improve communicative competence and personal effectiveness.',
      'Recognize underlying attitudes, assumptions, or perspectives related to social or cultural topics in various culturally significant communication events (e.g., speeches, media broadcasts, cultural performances).',
      'Use critical listening, reading, and viewing strategies, including cultural awareness and sensitivity, to interpret various forms of literary, media and digital communication.',
      'Identify main messages, implied meanings, and biases in public, civic, or culturally significant communication events (e.g., social media, podcasts, art exhibitions, festivals).',
      'Use culturally appropriate verbal and non-verbal strategies (e.g., politeness markers, conversation management signals and strategies) to communicate effectively in navigating diverse social and cultural settings.',
      'Demonstrate sensitivity to social roles, group dynamics, and cultural identities in face-to-face and online interactions.',
      'Compose public-facing texts (e.g., blogs, commentaries, social media advocacy posts, or short opinion pieces) that promote inclusivity, equity, or social awareness.',
      'Compose critical reviews of culturally significant texts (e.g., films, short stories, poetry, television series).',
      'Construct coherent arguments or narratives that reflect understanding of social responsibility, diversity, and shared values.',
      'Describe how cultural awareness and sensitivity influence processes of interpretation, engagement, and expression in diverse social contexts.',
      'Identify how content, structure, and language of spoken, written, and multimodal academic and technical texts are shaped by audience, purpose, and context.',
      'Use critical listening, reading, and viewing strategies in comprehending academic and technical texts.',
      'Interpret data represented in multimodal forms (e.g., charts, tables, figures).',
      'Employ appropriate strategies in understanding unfamiliar vocabulary, including specialized terminology.',
      'Use language, tone, and structure appropriately for audience, purpose, and context in discussing a variety of academic and technical topics.',
      'Follow procedures, instructions, or processes in spoken, written, or multimodal forms (e.g., figures, diagrams, charts) to successfully achieve outcomes.',
      'Participate constructively in academic or technical lectures, presentations, or discussions by formulating and asking questions, providing feedback, and responding appropriately.',
      'Collaborate on academic and technical tasks (e.g., project proposals, technical reports, lectures, manuals) to leverage individual knowledge and skills and optimize common goals.',
      'Compose well-structured academic and technical texts, showing awareness of audience and purpose (e.g., presentations with visual aids, essays, research and analysis reports).',
      'Explain concepts using appropriate academic and technical vocabulary and language, and multimodal representations (e.g., diagrams, graphs, charts, infographics).',
      'Condense spoken, written, or multimodal texts into diagrams, charts, outline, summary, synopsis, or paraphrase.',
      'Employ ethical considerations (e.g., citation methods, AI attribution/declaration, avoiding plagiarism) in producing extended spoken, written, or multimodal academic and technical texts.',
      'Describe processes of interpretation, engagement, and expression used for communication in academic and training contexts, demonstrating awareness of their purposes.',
      'Review one’s readiness to participate in academic and technical communication, identifying strengths and areas for growth to improve performance and shape life-long learning.',
      'Identify how content, structure, and language of spoken, written, and multimodal workplace and professional communication are shaped by audience, purpose, and context.',
      'Listen actively to workplace and professional communication (e.g., meetings, phone calls, presentations, instructions) to take accurate, well-organized notes for future reference and task completion.',
      'Use language, tone, and structure appropriately for audience, purpose, and context in discussing workplace and professional matters.',
      'Participate constructively in workplace and professional communication (e.g., conversations, meetings, negotiations, interviews, feedback sessions) by formulating and asking questions, providing feedback, and responding appropriately.',
      'Collaborate on workplace and professional tasks (e.g., proposals, reports, presentations, projects) to leverage individual knowledge and skills, and optimize common goals.',
      'Compose well-structured workplace and professional communication, showing awareness of audience and purpose (e.g., presentations with visual aids, emails, reports).',
      'Use appropriate conventions (e.g., layout, font choice, bullets, bolds, italics) and concise language to deliver effective workplace and professional communication.',
      'Produce professional profiles, resumés, and job and college applications, tailored for purpose and audience.',
      'Describe processes of interpretation and engagement used for communication in professional and workplace contexts, demonstrating awareness of their purposes.',
      'Describe processes of expression used for communication in professional and workplace contexts, demonstrating awareness of their purposes',
      'Review one’s readiness to participate in professional and workplace communication, identifying strengths and areas for sustained career growth.',
   ]),
};

export const MKG11_SUBJECT_CONFIG = {
   apiVersion: 3,
   summaryAreas: [
      {
         key: 'personal_interpersonal',
         label: 'Mga kontrolado at di-kontroladong personal at interpersonal na sitwasyong komunikatibo',
         start: 1,
         count: 11,
         mean: 9.3,
         stdDev: 1.67,
         ranges: [
            [0, 7.62, 'Beginner'],
            [7.63, 10.14, 'Basic'],
            [10.15, 11, 'Competent'],
         ],
      },
      {
         key: 'social_cultural',
         label: 'Mga sitwasyong komunikatibo na kinabibilangan ng iba’t ibang pangkat sosyal at kultural',
         start: 12,
         count: 10,
         mean: 6.8,
         stdDev: 2.4,
         ranges: [
            [0, 6.04, 'Beginner'],
            [6.05, 8.48, 'Basic'],
            [8.49, 10, 'Competent'],
         ],
      },
      {
         key: 'academic_technical',
         label: 'Akademiko at teknikal na tekstong pasalita, pasulat, at multimodal para sa tiyak na layon at awdyens',
         start: 22,
         count: 14,
         mean: 12.1,
         stdDev: 1.93,
         ranges: [
            [0, 10.16, 'Beginner'],
            [10.17, 13.07, 'Basic'],
            [13.08, 14, 'Competent'],
         ],
      },
      {
         key: 'correspondence',
         label: 'Iba’t ibang uri ng korespondensiya alinsunod sa mga kumbensiyon sa pagsulat',
         start: 36,
         count: 10,
         mean: 7.09,
         stdDev: 1.59,
         ranges: [
            [0, 5.49, 'Beginner'],
            [5.5, 7.87, 'Basic'],
            [7.88, 10, 'Competent'],
         ],
      },
   ],
   totalRanges: [
      [0, 33.33, 'Beginner'],
      [33.34, 42.09, 'Basic'],
      [42.10, 45, 'Competent'],
   ],
   sections: [
      {
         label: 'A. Mga kontrolado at di-kontroladong personal at interpersonal na sitwasyong komunikatibo',
         start: 1,
         end: 11,
      },
      {
         label: 'B. Mga sitwasyong komunikatibo na kinabibilangan ng iba’t ibang pangkat sosyal at kultural',
         start: 12,
         end: 21,
      },
      {
         label: 'C. Akademiko at teknikal na tekstong pasalita, pasulat, at multimodal para sa tiyak na layon at awdyens',
         start: 22,
         end: 35,
      },
      {
         label: 'D. Iba’t ibang uri ng korespondensiya alinsunod sa mga kumbensiyon sa pagsulat',
         start: 36,
         end: 45,
      },
   ],
   // Sub-competency labels group the item-level competencies below them. They are
   // headings only (no item index / score) and are rendered as sub-label rows by
   // the SHS report templates. start/end are 1-based item indexes, inclusive.
   subLabels: [
      {
         label: 'A-1. Pagbibigay-kahulugan sa mga tekstong pasalita, pasulat, at multimodal at kung paano ito hinuhubog ng awdyens, layon, at konteksto',
         start: 1,
         end: 3,
      },
      {
         label: 'A-2. Mabisang pakikilahok sa interaktibong komunikasyon gamit ang angkop na berbal at di-berbal na mga estratehiya',
         start: 4,
         end: 6,
      },
      {
         label: 'A-3. Malinaw at maayos na pagpapahayag ng mga ideya sa anyong pasalita, pasulat, at multimodal para sa tiyak na layon, awdyens, at konteksto',
         start: 7,
         end: 9,
      },
      {
         label: 'A-4. Pagninilay sa mga proseso ng pagbibigay-kahulugan, pakikilahok, at pagpapahayag sa personal at interpersonal na komunikasyon',
         start: 10,
         end: 11,
      },
      {
         label: 'B-1. Pagbibigay-kahulugan sa mga tekstong pasalita, pasulat, at multimodal at kung paano ito hinuhubog ng kontekstong kultural, mga kaugalian, at panlipunang pamantayan at dinamika',
         start: 12,
         end: 14,
      },
      {
         label: 'B-2. Mabisang pakikilahok sa komunikasyong panlipunan gamit ang berbal at di-berbal na mga estratehiyang angkop sa kultura',
         start: 15,
         end: 16,
      },
      {
         label: 'B-3. Malinaw na pagpapahayag ng mga ideya gamit ang inklusibo at magalang na wika sa anyong pasalita, pasulat, at multimodal para sa tiyak na layon, awdyens, at konteksto',
         start: 17,
         end: 19,
      },
      {
         label: 'B-4. Pagninilay sa mga proseso ng pagbibigay-kahulugan, pakikilahok, at pagpapahayag sa komunikasyong sosyal at kultural',
         start: 20,
         end: 21,
      },
      {
         label: 'C-1. Pagbibigay-kahulugan sa mga akademiko at teknikal na tekstong pasalita, pasulat, at multimodal at kung paano ito hinuhubog ng awdyens, layon, at konteksto',
         start: 22,
         end: 25,
      },
      {
         label: 'C-2. Mabisang pakikilahok sa interaktibong komunikasyon sa kontekstong akademiko at pampagsasanay',
         start: 26,
         end: 29,
      },
      {
         label: 'C-3. Malinaw at maayos na pagpapahayag ng mga ideya sa anyong pasalita, pasulat, at multimodal para sa tiyak na layon, awdyens, at konteksto',
         start: 30,
         end: 33,
      },
      {
         label: 'C-4. Pagninilay sa mga proseso ng pagbibigay-kahulugan, pakikilahok, at pagpapahayag sa kontekstong akademiko at pampagsasanay',
         start: 34,
         end: 35,
      },
      {
         label: 'D-1. Pagbibigay-kahulugan sa mga propesyonal at pantrabahong tekstong pasalita, pasulat, at multimodal at kung paano ito hinuhubog ng awdyens, layon, at konteksto',
         start: 36,
         end: 37,
      },
      {
         label: 'D-2. Mabisang pakikilahok sa interaktibong komunikasyon sa kontekstong pantrabaho at propesyonal',
         start: 38,
         end: 40,
      },
      {
         label: 'D-3. Malinaw at maayos na pagpapahayag ng mga ideya sa anyong pasalita, pasulat, at multimodal para sa tiyak na layon, awdyens, at konteksto',
         start: 41,
         end: 43,
      },
      {
         label: 'D-4. Pagninilay sa mga proseso ng pagbibigay-kahulugan, pakikilahok, at pagpapahayag sa komunikasyong propesyonal at pantrabaho',
         start: 44,
         end: 45,
      },
   ],
   competencies: toCompetencies([
      'Natutukoy kung paano ginagamit nang may layunin ang wika at tono sa pagtalakay ng iba’t ibang personal at interpersonal na paksa',
      'Nahihinuha ang mga pangunahing ideya mula sa mga tekstong pasalita, pasulat, at multimodal (hal. naitala at aktuwal na personal na interaksyon)',
      'Nasusuri ang nilalaman at layunin ng personal at interpersonal na komunikasyon, gaya ng pag-uusap at korespondensiya',
      'Nakagagamit ng angkop na wika, tono, at estruktura ayon sa awdyens, layon at konteksto sa pagtalakay ng iba’t ibang personal at interpersonal na paksa',
      'Nakagagamit ng magagalang na pananalita at mga estratehiya sa pagpapatuloy ng usapan (hal. pagpapasimula ng paksa, pagpapalit o pagkontrol ng daloy ng usapan, turn-taking, pagbibigay ng kumpirmasyon o back-channelling, pagbibigay ng tugon, at pagtatapos ng usapan)',
      'Nakagagamit ng angkop na di-berbal na mga estratehiya upang mapahusay ang kalidad ng komunikasyong personal at interpersonal',
      'Nakabubuo ng maayos na personal at interpersonal na komunikasyon na nagpapakita ng malinaw na layunin at pag-unawa sa awdyens (hal. pagtatanong, pagkukwento, paglalahad ng obserbasyon, pagsasalaysay ng karanasan, o pagpapahayag ng opinyon)',
      'Nakalalahok sa komunikasyong intrapersonal (hal. pagsulat ng talaarawan o dyornal, pagbuo ng social media profile) upang mapagnilayan ang mga natutuhan at karanasan, makapagtakda ng layunin, at makagawa ng online na presensiya habang pinoprotektahan ang mga pribadong datos',
      'Nakagagamit ng angkop at mabisang wika at estruktura (hal. paggamit ng mga panandang kohesyong gramatikal) sa iba’t ibang layunin',
      'Naipaliliwanag ang mga proseso ng pagbibigay-kahulugan, pakikilahok, at pagpapahayag sa mga personal at interpersonal na konteksto na nagpapamalas ng kamalayan sa kanilang layunin',
      'Nakasusuri ng sariling pakikilahok sa komunikasyong personal at interpersonal na may pagtukoy sa mga kalakasan at mga aspektong nangangailangan pa ng paglinang upang mapaunlad ang kakayahang komunikatibo',
      'Naipaliliwanag ang mga nakapaloob na saloobin, paniniwala, o pananaw sa mga paksang sosyal at kultural sa iba’t ibang sitwasyong pangkomunikasyon (hal. talumpati, brodkast pangmidya, kultural na pagtatanghal)',
      'Nagagamit ang iba’t ibang estratehiya sa kritikal na pakikinig, pagbabasa, at panonood, kabilang ang kamalayang kultural at sensibilidad upang bigyan-kahulugan ang iba’t ibang anyo ng panitikan, midya, at komunikasyong dihital',
      'Nahihinuha ang pangunahing mensahe, ipinahihiwatig na kahulugan, at pagkiling o bias sa mga komunikasyong pampubliko, sibiko, o kultural (hal. social media post, podcast, art exhibit, pista o festival)',
      'Nakagagamit ng angkop na berbal at di-berbal na mga estratehiya (hal. magagalang na pananalita, hudyat at estratehiya sa pagpapatuloy ng usapan) upang mabisang makipag-ugnayan tungkol sa iba’t ibang kontekstong sosyal at kultural',
      'Naipakikita ang sensibilidad sa mga panlipunang gampanin, pangkatang dinamika at kultural na pagkakakilanlan sa mga interaksyong face-to-face at online',
      'Nakabubuo ng mga tekstong public-facing (hal. blog, komentaryo, adbokasiyang post sa social media, o maikling opinyon o kolum) na nagsusulong ng pagiging inklusibo, pagkakapantay-pantay, o kamalayang panlipunan',
      'Nakabubuo ng mga mapanuring rebyu ng mga tekstong may kabuluhang kultural (hal. pelikula, maikling kuwento, tula, serye sa telebisyon)',
      'Nakabubuo ng magkakaugnay na argumento o naratibong sumasalamin sa pag-unawa sa panlipunang pananagutan, pagkakaiba-iba, at mga kaugalian',
      'Naipaliliwanag kung paano nakaaapekto ang kamalayang kultural at sensibilidad sa mga proseso ng pagbibigay-kahulugan, pakikilahok, at pagpapahayag sa iba’t ibang kontekstong panlipunan',
      'Nakasusuri ng sariling pakikilahok sa komunikasyong panlipunan o interkultural na may pagtukoy sa mga kalakasan at mga aspektong nangangailangan ng paglinang sa pagsulong ng inklusibo at etikal na diskurso',
      'Natutukoy kung paano ang nilalaman, estruktura, at wika ng mga pasalita, pasulat, o multimodal na tekstong akademiko at teknikal ay hinuhubog ng awdyens, layon, at konteksto',
      'Nagagamit ang iba’t ibang estratehiya sa kritikal na pakikinig, pagbabasa, at panonood upang maunawaan ang mga tekstong akademiko at teknikal',
      'Nabibigyang-kahulugan ang datos na nakalarawan sa mga multimodal na anyo (hal. tsart, talahanayan, pigura, atbp.)',
      'Nagagamit ang angkop na mga estratehiya sa pag-unawa ng mga salitang di-pamilyar, kabilang na ang espesyalisadong termino',
      'Nakagagamit ng angkop na wika, tono, at estruktura ayon sa awdyens, layon at konteksto sa pagtalakay ng iba’t ibang paksang akademiko at teknikal',
      'Nakasusunod sa mga pamamaraan, panuto, o proseso sa anyong pasalita, pasulat, o multimodal (hal. pigura, dayagram, tsart, atbp.) upang matagumpay na maisakatuparan ang layunin o matamo ang inaasahang resulta',
      'Nakikilahok nang may kabuluhan sa mga akademiko o teknikal na lektyur, presentasyon, o diskusyon sa pamamagitan ng pagtatanong, pagbibigay ng puna o mungkahi, at angkop na pagtugon',
      'Nakikibahagi sa kolaboratibong gawaing akademiko at teknikal (hal. panukalang proyekto, teknikal na ulat, lektyura, manwal, atbp.) upang magamit ang kaalaman at kakayahan ng bawat isa at makamit ang kolektibong layunin',
      'Nakabubuo ng maayos na tekstong akademiko at teknikal na nagpapamalas ng kamalayan at pagsasaalang-alang sa awdyens at layon (hal. presentasyong may visual aid, sanaysay, ulat sa pananaliksik at pagsusuri, atbp.)',
      'Naipaliliwanag ang mga konsepto gamit ang angkop na bokabularyo at wikang akademiko at teknikal at representasyong multimodal (hal. dayagram, grap, tsart, infographic, atbp.)',
      'Nakagagawa ng dayagram, tsart, balangkas, buod, sinopsis, o paraphrase mula sa mga tekstong pasalita, pasulat, o multimodal',
      'Nakagagamit ng mga etikal na pamantayan (hal. wastong pagsipi, deklarasyon ng paggamit ng AI, pag-iwas sa plagiarism, atbp.) sa pagbuo ng mas mahababang akademiko at teknikal na tekstong pasalita, pasulat at multimodal',
      'Naipaliliwanag ang mga proseso ng pagbibigay-kahulugan, pakikilahok, at pagpapahayag sa mga kontekstong akademiko at pampagsasanay na nagpapamalas ng kamalayan sa kanilang layunin',
      'Nakasusuri ng sariling pakikilahok sa kontekstong akademiko at pampagsasanay may pagtukoy sa mga kalakasan at mga aspektong nangangailangan ng paglinang upang mapaunlad ang pagganap at mahubog ang panghabambuhay na pagkatuto',
      'Natutukoy ang paggamit ng wika at tono nang may layunin sa pagtalakay ng iba’t ibang propesyonal at pantrabahong paksa',
      'Nakikinig nang aktibo sa komunikasyong pantrabaho at propesyonal (hal. mga pulong, tawag sa telepono, presentasyon, panuto, atbp.) upang makapagtala ng tumpak at organisadong impormasyon bilang batayan sa pagsasakatuparan ng gawain at sanggunian sa hinaharap',
      'Nakagagamit ng angkop na wika, tono, at estruktura ayon sa awdyens, layon at konteksto sa pagtalakay ng iba’t ibang usaping propesyonal o pantrabaho',
      'Nakikilahok nang may kabuluhan sa komunikasyong propesyonal o pantrabaho (hal. mga panayam, pulong, negosasyon, sesyon ng pagbibigay ng puna, atbp.) sa pamamagitan ng pagtatanong, pagbibigay ng puna o mungkahi, at angkop na pagtugon',
      'Nakikibahagi sa mga kolaboratibong gawaing pantrabaho o propesyonal (hal. paggawa ng panukala, ulat, presentasyon, o proyekto) upang magamit ang kaalaman at kakayahan ng bawat isa at makamit ang kolektibong layunin',
      'Nakabubuo ng maayos na komunikasyong propesyonal o pantrabaho na nagpapamalas ng kamalayan sa awdyens at layon (hal. presentasyong na may visual aid, email, ulat, atbp.)',
      'Nagagamit ang angkop na kumbensiyon sa pagsulat (hal. anyo at disenyo, font, bulleting at numbering, bolding, italicization, atbp.) at tiyak at malinaw na wika upang makapagpahayag ng mabisang komunikasyong propesyonal at pantrabaho',
      'Nakabubuo ng mga propesyonal na profile, résumé, at aplikasyon sa trabaho o kolehiyo na angkop sa layon at awdyens',
      'Naipaliliwanag ang mga proseso ng pagbibigay-kahulugan, pakikilahok, at pagpapahayag sa mga kontekstong propesyonal at pantrabaho na nagpapamalas ng kamalayan sa kanilang layunin',
      'Nasusuri ang sariling kahandaan makilahok sa komunikasyong propesyonal at pantrabaho na may pagtukoy sa mga kalakasan at mga aspektong nangangailangan ng paglinang para sa aktuwal na aplikasyon sa mundo ng trabaho',
   ]),
};

/* ============================================================================
 * SUBJECT_CONFIG TEMPLATE
 * ----------------------------------------------------------------------------
 * Copy the block below, rename <PREFIX>_SUBJECT_CONFIG (e.g. MKG11_SUBJECT_CONFIG),
 * and fill in the values for the new subject. The export name MUST match the
 * `${prefix}_SUBJECT_CONFIG` key used in reportConfigResolver.js (SHS_SUBJECT_PREFIX).
 *
 * Structure notes:
 *  - apiVersion: keep 3 unless the renderer changes.
 *  - summaryAreas[]: one entry per sub-area / summary. Each area describes a
 *    contiguous range of item indexes and how to bucket its score.
 *      key       : unique snake_case identifier for the area.
 *      label     : display title shown in the report.
 *      start     : 1-based index of the FIRST item in this area.
 *      count     : number of items in this area.
 *      mean      : mean raw score of this area (from item analysis).
 *      stdDev    : standard deviation of this area's raw score.
 *      ranges    : [min, max, level] buckets, inclusive on both ends.
 *  - totalRanges[]: same [min, max, level] buckets but for the TOTAL raw score
 *    (i.e. the last range's max === total number of items).
 *  - sections[]: the A/B/C/D... sections; each has a label plus start/end
 *    (1-based, inclusive) item indexes. Sections should cover every item once.
 *  - competencies[]: pass an ordered array of competency labels to the
 *    toCompetencies() helper. Index is auto-assigned (1, 2, 3, ...), so the
 *    array order MUST match the item order.
 * ----------------------------------------------------------------------------
 *
  export const <PREFIX>_SUBJECT_CONFIG = {
     apiVersion: 3,
     summaryAreas: [
        {
           key: 'area_one',
           label: 'Area One Label',
           start: 1,
           count: 10,
           mean: 7.5,
           stdDev: 2.1,
           ranges: [
              [0, 6.5, 'Beginner'],
              [6.51, 9, 'Basic'],
              [9.01, 10, 'Competent'],
           ],
        },
        {
           key: 'area_two',
           label: 'Area Two Label',
           start: 11,
           count: 10,
           mean: 6.8,
           stdDev: 2.4,
           ranges: [
              [0, 5.6, 'Beginner'],
              [5.61, 8.2, 'Basic'],
              [8.21, 10, 'Competent'],
           ],
        },
     ],
     totalRanges: [
        [0, 12.5, 'Beginner'],
        [12.51, 16.9, 'Basic'],
        [16.91, 20, 'Competent'],
     ],
     sections: [
        { label: 'A. Area One Label', start: 1, end: 10 },
        { label: 'B. Area Two Label', start: 11, end: 20 },
     ],
     competencies: toCompetencies([
        'Competency statement for item 1',
        'Competency statement for item 2',
        'Competency statement for item 3',
        'Competency statement for item 4',
        'Competency statement for item 5',
        'Competency statement for item 6',
        'Competency statement for item 7',
        'Competency statement for item 8',
        'Competency statement for item 9',
        'Competency statement for item 10',
        'Competency statement for item 11',
        'Competency statement for item 12',
        'Competency statement for item 13',
        'Competency statement for item 14',
        'Competency statement for item 15',
        'Competency statement for item 16',
        'Competency statement for item 17',
        'Competency statement for item 18',
        'Competency statement for item 19',
        'Competency statement for item 20',
     ]),
  };
 * ========================================================================== */
